// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/v1/app.proto" (package "viam.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppService } from "./app";
import type { DeleteFirebaseConfigResponse } from "./app";
import type { DeleteFirebaseConfigRequest } from "./app";
import type { GetFirebaseConfigResponse } from "./app";
import type { GetFirebaseConfigRequest } from "./app";
import type { SetFirebaseConfigResponse } from "./app";
import type { SetFirebaseConfigRequest } from "./app";
import type { GetDevicePushTokensResponse } from "./app";
import type { GetDevicePushTokensRequest } from "./app";
import type { DeleteDevicePushTokenResponse } from "./app";
import type { DeleteDevicePushTokenRequest } from "./app";
import type { UploadDevicePushTokenResponse } from "./app";
import type { UploadDevicePushTokenRequest } from "./app";
import type { GetAppBrandingResponse } from "./app";
import type { GetAppBrandingRequest } from "./app";
import type { GetAppContentResponse } from "./app";
import type { GetAppContentRequest } from "./app";
import type { CreateKeyFromExistingKeyAuthorizationsResponse } from "./app";
import type { CreateKeyFromExistingKeyAuthorizationsRequest } from "./app";
import type { RotateKeyResponse } from "./app";
import type { RotateKeyRequest } from "./app";
import type { RenameKeyResponse } from "./app";
import type { RenameKeyRequest } from "./app";
import type { ListKeysResponse } from "./app";
import type { ListKeysRequest } from "./app";
import type { DeleteKeyResponse } from "./app";
import type { DeleteKeyRequest } from "./app";
import type { CreateKeyResponse } from "./app";
import type { CreateKeyRequest } from "./app";
import type { UndeprecateRegistryItemVersionResponse } from "./app";
import type { UndeprecateRegistryItemVersionRequest } from "./app";
import type { DeprecateRegistryItemVersionResponse } from "./app";
import type { DeprecateRegistryItemVersionRequest } from "./app";
import type { ListModulesResponse } from "./app";
import type { ListModulesRequest } from "./app";
import type { GetModuleResponse } from "./app";
import type { GetModuleRequest } from "./app";
import type { UploadModuleFileResponse } from "./app";
import type { UploadModuleFileRequest } from "./app";
import type { ClientStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { UpdateModuleResponse } from "./app";
import type { UpdateModuleRequest } from "./app";
import type { CreateModuleResponse } from "./app";
import type { CreateModuleRequest } from "./app";
import type { UndeprecateRegistryItemResponse } from "./app";
import type { UndeprecateRegistryItemRequest } from "./app";
import type { DeprecateRegistryItemResponse } from "./app";
import type { DeprecateRegistryItemRequest } from "./app";
import type { TransferRegistryItemResponse } from "./app";
import type { TransferRegistryItemRequest } from "./app";
import type { RenameRegistryItemResponse } from "./app";
import type { RenameRegistryItemRequest } from "./app";
import type { DeleteRegistryItemResponse } from "./app";
import type { DeleteRegistryItemRequest } from "./app";
import type { ListRegistryItemsResponse } from "./app";
import type { ListRegistryItemsRequest } from "./app";
import type { UpdateRegistryItemResponse } from "./app";
import type { UpdateRegistryItemRequest } from "./app";
import type { CreateRegistryItemResponse } from "./app";
import type { CreateRegistryItemRequest } from "./app";
import type { GetRegistryItemResponse } from "./app";
import type { GetRegistryItemRequest } from "./app";
import type { CheckPermissionsResponse } from "./app";
import type { CheckPermissionsRequest } from "./app";
import type { ListAuthorizationsResponse } from "./app";
import type { ListAuthorizationsRequest } from "./app";
import type { ChangeRoleResponse } from "./app";
import type { ChangeRoleRequest } from "./app";
import type { RemoveRoleResponse } from "./app";
import type { RemoveRoleRequest } from "./app";
import type { AddRoleResponse } from "./app";
import type { AddRoleRequest } from "./app";
import type { DeleteFragmentTagResponse } from "./app";
import type { DeleteFragmentTagRequest } from "./app";
import type { SetFragmentTagResponse } from "./app";
import type { SetFragmentTagRequest } from "./app";
import type { GetFragmentUsageResponse } from "./app";
import type { GetFragmentUsageRequest } from "./app";
import type { GetFragmentHistoryResponse } from "./app";
import type { GetFragmentHistoryRequest } from "./app";
import type { ListMachineSummariesResponse } from "./app";
import type { ListMachineSummariesRequest } from "./app";
import type { ListMachineFragmentsResponse } from "./app";
import type { ListMachineFragmentsRequest } from "./app";
import type { ListNestedFragmentsResponse } from "./app";
import type { ListNestedFragmentsRequest } from "./app";
import type { DeleteFragmentResponse } from "./app";
import type { DeleteFragmentRequest } from "./app";
import type { UpdateFragmentResponse } from "./app";
import type { UpdateFragmentRequest } from "./app";
import type { CreateFragmentResponse } from "./app";
import type { CreateFragmentRequest } from "./app";
import type { GetFragmentResponse } from "./app";
import type { GetFragmentRequest } from "./app";
import type { ListFragmentsResponse } from "./app";
import type { ListFragmentsRequest } from "./app";
import type { DeleteRobotResponse } from "./app";
import type { DeleteRobotRequest } from "./app";
import type { UpdateRobotResponse } from "./app";
import type { UpdateRobotRequest } from "./app";
import type { NewRobotResponse } from "./app";
import type { NewRobotRequest } from "./app";
import type { ListRobotsForOrgResponse } from "./app";
import type { ListRobotsForOrgRequest } from "./app";
import type { ListRobotsForLocationsResponse } from "./app";
import type { ListRobotsForLocationsRequest } from "./app";
import type { ListRobotsResponse } from "./app";
import type { ListRobotsRequest } from "./app";
import type { DeleteRobotPartSecretResponse } from "./app";
import type { DeleteRobotPartSecretRequest } from "./app";
import type { CreateRobotPartSecretResponse } from "./app";
import type { CreateRobotPartSecretRequest } from "./app";
import type { MarkPartForRestartResponse } from "./app";
import type { MarkPartForRestartRequest } from "./app";
import type { MarkPartAsMainResponse } from "./app";
import type { MarkPartAsMainRequest } from "./app";
import type { GetRobotAPIKeysResponse } from "./app";
import type { GetRobotAPIKeysRequest } from "./app";
import type { UpdateRobotPartMetadataResponse } from "./app";
import type { UpdateRobotPartMetadataRequest } from "./app";
import type { GetRobotPartMetadataResponse } from "./app";
import type { GetRobotPartMetadataRequest } from "./app";
import type { DeleteRobotPartResponse } from "./app";
import type { DeleteRobotPartRequest } from "./app";
import type { NewRobotPartResponse } from "./app";
import type { NewRobotPartRequest } from "./app";
import type { UpdateRobotPartResponse } from "./app";
import type { UpdateRobotPartRequest } from "./app";
import type { GetRobotPartHistoryResponse } from "./app";
import type { GetRobotPartHistoryRequest } from "./app";
import type { TailRobotPartLogsResponse } from "./app";
import type { TailRobotPartLogsRequest } from "./app";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { GetRobotPartLogsResponse } from "./app";
import type { GetRobotPartLogsRequest } from "./app";
import type { GetRobotPartByNameAndLocationResponse } from "./app";
import type { GetRobotPartByNameAndLocationRequest } from "./app";
import type { GetRobotPartResponse } from "./app";
import type { GetRobotPartRequest } from "./app";
import type { GetRobotPartsResponse } from "./app";
import type { GetRobotPartsRequest } from "./app";
import type { GetRoverRentalRobotsResponse } from "./app";
import type { GetRoverRentalRobotsRequest } from "./app";
import type { UpdateRobotMetadataResponse } from "./app";
import type { UpdateRobotMetadataRequest } from "./app";
import type { GetRobotMetadataResponse } from "./app";
import type { GetRobotMetadataRequest } from "./app";
import type { GetRobotResponse } from "./app";
import type { GetRobotRequest } from "./app";
import type { DeleteLocationSecretResponse } from "./app";
import type { DeleteLocationSecretRequest } from "./app";
import type { CreateLocationSecretResponse } from "./app";
import type { CreateLocationSecretRequest } from "./app";
import type { LocationAuthResponse } from "./app";
import type { LocationAuthRequest } from "./app";
import type { UnshareLocationResponse } from "./app";
import type { UnshareLocationRequest } from "./app";
import type { ShareLocationResponse } from "./app";
import type { ShareLocationRequest } from "./app";
import type { ListLocationsResponse } from "./app";
import type { ListLocationsRequest } from "./app";
import type { UpdateLocationMetadataResponse } from "./app";
import type { UpdateLocationMetadataRequest } from "./app";
import type { GetLocationMetadataResponse } from "./app";
import type { GetLocationMetadataRequest } from "./app";
import type { DeleteLocationResponse } from "./app";
import type { DeleteLocationRequest } from "./app";
import type { UpdateLocationResponse } from "./app";
import type { UpdateLocationRequest } from "./app";
import type { GetLocationResponse } from "./app";
import type { GetLocationRequest } from "./app";
import type { CreateLocationResponse } from "./app";
import type { CreateLocationRequest } from "./app";
import type { CreateOAuthAppUserResponse } from "./app";
import type { CreateOAuthAppUserRequest } from "./app";
import type { ListOAuthAppsResponse } from "./app";
import type { ListOAuthAppsRequest } from "./app";
import type { DeleteOAuthAppResponse } from "./app";
import type { DeleteOAuthAppRequest } from "./app";
import type { UpdateOAuthAppResponse } from "./app";
import type { UpdateOAuthAppRequest } from "./app";
import type { ReadOAuthAppResponse } from "./app";
import type { ReadOAuthAppRequest } from "./app";
import type { CreateOAuthAppResponse } from "./app";
import type { CreateOAuthAppRequest } from "./app";
import type { DisableAuthServiceResponse } from "./app";
import type { DisableAuthServiceRequest } from "./app";
import type { EnableAuthServiceResponse } from "./app";
import type { EnableAuthServiceRequest } from "./app";
import type { OrganizationGetLogoResponse } from "./app";
import type { OrganizationGetLogoRequest } from "./app";
import type { OrganizationSetLogoResponse } from "./app";
import type { OrganizationSetLogoRequest } from "./app";
import type { OrganizationGetSupportEmailResponse } from "./app";
import type { OrganizationGetSupportEmailRequest } from "./app";
import type { OrganizationSetSupportEmailResponse } from "./app";
import type { OrganizationSetSupportEmailRequest } from "./app";
import type { GetBillingServiceConfigResponse } from "./app";
import type { GetBillingServiceConfigRequest } from "./app";
import type { UpdateBillingServiceResponse } from "./app";
import type { UpdateBillingServiceRequest } from "./app";
import type { DisableBillingServiceResponse } from "./app";
import type { DisableBillingServiceRequest } from "./app";
import type { EnableBillingServiceResponse } from "./app";
import type { EnableBillingServiceRequest } from "./app";
import type { ResendOrganizationInviteResponse } from "./app";
import type { ResendOrganizationInviteRequest } from "./app";
import type { DeleteOrganizationInviteResponse } from "./app";
import type { DeleteOrganizationInviteRequest } from "./app";
import type { DeleteOrganizationMemberResponse } from "./app";
import type { DeleteOrganizationMemberRequest } from "./app";
import type { UpdateOrganizationInviteAuthorizationsResponse } from "./app";
import type { UpdateOrganizationInviteAuthorizationsRequest } from "./app";
import type { CreateOrganizationInviteResponse } from "./app";
import type { CreateOrganizationInviteRequest } from "./app";
import type { ListOrganizationMembersResponse } from "./app";
import type { ListOrganizationMembersRequest } from "./app";
import type { UpdateOrganizationMetadataResponse } from "./app";
import type { UpdateOrganizationMetadataRequest } from "./app";
import type { GetOrganizationMetadataResponse } from "./app";
import type { GetOrganizationMetadataRequest } from "./app";
import type { DeleteOrganizationResponse } from "./app";
import type { DeleteOrganizationRequest } from "./app";
import type { UpdateOrganizationNamespaceResponse } from "./app";
import type { UpdateOrganizationNamespaceRequest } from "./app";
import type { UpdateOrganizationResponse } from "./app";
import type { UpdateOrganizationRequest } from "./app";
import type { GetOrganizationNamespaceAvailabilityResponse } from "./app";
import type { GetOrganizationNamespaceAvailabilityRequest } from "./app";
import type { GetOrganizationResponse } from "./app";
import type { GetOrganizationRequest } from "./app";
import type { SearchOrganizationsResponse } from "./app";
import type { SearchOrganizationsRequest } from "./app";
import type { ListOrganizationsByUserResponse } from "./app";
import type { ListOrganizationsByUserRequest } from "./app";
import type { GetOrganizationsWithAccessToLocationResponse } from "./app";
import type { GetOrganizationsWithAccessToLocationRequest } from "./app";
import type { ListOrganizationsResponse } from "./app";
import type { ListOrganizationsRequest } from "./app";
import type { CreateOrganizationResponse } from "./app";
import type { CreateOrganizationRequest } from "./app";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetUserIDByEmailResponse } from "./app";
import type { GetUserIDByEmailRequest } from "./app";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * Users
 *
 * @generated from protobuf service viam.app.v1.AppService
 */
export interface IAppServiceClient {
    /**
     * Get the id of the user with the email
     *
     * @generated from protobuf rpc: GetUserIDByEmail(viam.app.v1.GetUserIDByEmailRequest) returns (viam.app.v1.GetUserIDByEmailResponse);
     */
    getUserIDByEmail(input: GetUserIDByEmailRequest, options?: RpcOptions): UnaryCall<GetUserIDByEmailRequest, GetUserIDByEmailResponse>;
    // Organizations

    /**
     * Create a new organization
     *
     * @generated from protobuf rpc: CreateOrganization(viam.app.v1.CreateOrganizationRequest) returns (viam.app.v1.CreateOrganizationResponse);
     */
    createOrganization(input: CreateOrganizationRequest, options?: RpcOptions): UnaryCall<CreateOrganizationRequest, CreateOrganizationResponse>;
    /**
     * List organizations
     *
     * @generated from protobuf rpc: ListOrganizations(viam.app.v1.ListOrganizationsRequest) returns (viam.app.v1.ListOrganizationsResponse);
     */
    listOrganizations(input: ListOrganizationsRequest, options?: RpcOptions): UnaryCall<ListOrganizationsRequest, ListOrganizationsResponse>;
    /**
     * Get all organizations that have access to a location.
     *
     * @generated from protobuf rpc: GetOrganizationsWithAccessToLocation(viam.app.v1.GetOrganizationsWithAccessToLocationRequest) returns (viam.app.v1.GetOrganizationsWithAccessToLocationResponse);
     */
    getOrganizationsWithAccessToLocation(input: GetOrganizationsWithAccessToLocationRequest, options?: RpcOptions): UnaryCall<GetOrganizationsWithAccessToLocationRequest, GetOrganizationsWithAccessToLocationResponse>;
    /**
     * List the organizations a user belongs to
     *
     * @generated from protobuf rpc: ListOrganizationsByUser(viam.app.v1.ListOrganizationsByUserRequest) returns (viam.app.v1.ListOrganizationsByUserResponse);
     */
    listOrganizationsByUser(input: ListOrganizationsByUserRequest, options?: RpcOptions): UnaryCall<ListOrganizationsByUserRequest, ListOrganizationsByUserResponse>;
    /**
     * Search organizations by a couple fields
     *
     * @generated from protobuf rpc: SearchOrganizations(viam.app.v1.SearchOrganizationsRequest) returns (viam.app.v1.SearchOrganizationsResponse);
     */
    searchOrganizations(input: SearchOrganizationsRequest, options?: RpcOptions): UnaryCall<SearchOrganizationsRequest, SearchOrganizationsResponse>;
    /**
     * Get an organization
     *
     * @generated from protobuf rpc: GetOrganization(viam.app.v1.GetOrganizationRequest) returns (viam.app.v1.GetOrganizationResponse);
     */
    getOrganization(input: GetOrganizationRequest, options?: RpcOptions): UnaryCall<GetOrganizationRequest, GetOrganizationResponse>;
    /**
     * Checks for namespace availablity throughout all orgs.
     *
     * @generated from protobuf rpc: GetOrganizationNamespaceAvailability(viam.app.v1.GetOrganizationNamespaceAvailabilityRequest) returns (viam.app.v1.GetOrganizationNamespaceAvailabilityResponse);
     */
    getOrganizationNamespaceAvailability(input: GetOrganizationNamespaceAvailabilityRequest, options?: RpcOptions): UnaryCall<GetOrganizationNamespaceAvailabilityRequest, GetOrganizationNamespaceAvailabilityResponse>;
    /**
     * Update an organization
     *
     * @generated from protobuf rpc: UpdateOrganization(viam.app.v1.UpdateOrganizationRequest) returns (viam.app.v1.UpdateOrganizationResponse);
     */
    updateOrganization(input: UpdateOrganizationRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationRequest, UpdateOrganizationResponse>;
    /**
     * Update an organization's namespace if it's already been set.
     *
     * @generated from protobuf rpc: UpdateOrganizationNamespace(viam.app.v1.UpdateOrganizationNamespaceRequest) returns (viam.app.v1.UpdateOrganizationNamespaceResponse);
     */
    updateOrganizationNamespace(input: UpdateOrganizationNamespaceRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationNamespaceRequest, UpdateOrganizationNamespaceResponse>;
    /**
     * Delete an organization
     *
     * @generated from protobuf rpc: DeleteOrganization(viam.app.v1.DeleteOrganizationRequest) returns (viam.app.v1.DeleteOrganizationResponse);
     */
    deleteOrganization(input: DeleteOrganizationRequest, options?: RpcOptions): UnaryCall<DeleteOrganizationRequest, DeleteOrganizationResponse>;
    /**
     * Get user-defined metadata for an organization
     *
     * @generated from protobuf rpc: GetOrganizationMetadata(viam.app.v1.GetOrganizationMetadataRequest) returns (viam.app.v1.GetOrganizationMetadataResponse);
     */
    getOrganizationMetadata(input: GetOrganizationMetadataRequest, options?: RpcOptions): UnaryCall<GetOrganizationMetadataRequest, GetOrganizationMetadataResponse>;
    /**
     * Update user-defined metadata for an organization
     *
     * @generated from protobuf rpc: UpdateOrganizationMetadata(viam.app.v1.UpdateOrganizationMetadataRequest) returns (viam.app.v1.UpdateOrganizationMetadataResponse);
     */
    updateOrganizationMetadata(input: UpdateOrganizationMetadataRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationMetadataRequest, UpdateOrganizationMetadataResponse>;
    /**
     * List all members of an organization and all invited members to the organization.
     *
     * @generated from protobuf rpc: ListOrganizationMembers(viam.app.v1.ListOrganizationMembersRequest) returns (viam.app.v1.ListOrganizationMembersResponse);
     */
    listOrganizationMembers(input: ListOrganizationMembersRequest, options?: RpcOptions): UnaryCall<ListOrganizationMembersRequest, ListOrganizationMembersResponse>;
    /**
     * Create an organization invite to an organization
     *
     * @generated from protobuf rpc: CreateOrganizationInvite(viam.app.v1.CreateOrganizationInviteRequest) returns (viam.app.v1.CreateOrganizationInviteResponse);
     */
    createOrganizationInvite(input: CreateOrganizationInviteRequest, options?: RpcOptions): UnaryCall<CreateOrganizationInviteRequest, CreateOrganizationInviteResponse>;
    /**
     * Update the authorizations attached to an organization invite
     *
     * @generated from protobuf rpc: UpdateOrganizationInviteAuthorizations(viam.app.v1.UpdateOrganizationInviteAuthorizationsRequest) returns (viam.app.v1.UpdateOrganizationInviteAuthorizationsResponse);
     */
    updateOrganizationInviteAuthorizations(input: UpdateOrganizationInviteAuthorizationsRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationInviteAuthorizationsRequest, UpdateOrganizationInviteAuthorizationsResponse>;
    /**
     * Delete an organization member from an organization
     *
     * @generated from protobuf rpc: DeleteOrganizationMember(viam.app.v1.DeleteOrganizationMemberRequest) returns (viam.app.v1.DeleteOrganizationMemberResponse);
     */
    deleteOrganizationMember(input: DeleteOrganizationMemberRequest, options?: RpcOptions): UnaryCall<DeleteOrganizationMemberRequest, DeleteOrganizationMemberResponse>;
    /**
     * Delete an organization invite
     *
     * @generated from protobuf rpc: DeleteOrganizationInvite(viam.app.v1.DeleteOrganizationInviteRequest) returns (viam.app.v1.DeleteOrganizationInviteResponse);
     */
    deleteOrganizationInvite(input: DeleteOrganizationInviteRequest, options?: RpcOptions): UnaryCall<DeleteOrganizationInviteRequest, DeleteOrganizationInviteResponse>;
    /**
     * Resend an organization invite
     *
     * @generated from protobuf rpc: ResendOrganizationInvite(viam.app.v1.ResendOrganizationInviteRequest) returns (viam.app.v1.ResendOrganizationInviteResponse);
     */
    resendOrganizationInvite(input: ResendOrganizationInviteRequest, options?: RpcOptions): UnaryCall<ResendOrganizationInviteRequest, ResendOrganizationInviteResponse>;
    // Third party

    /**
     * @generated from protobuf rpc: EnableBillingService(viam.app.v1.EnableBillingServiceRequest) returns (viam.app.v1.EnableBillingServiceResponse);
     */
    enableBillingService(input: EnableBillingServiceRequest, options?: RpcOptions): UnaryCall<EnableBillingServiceRequest, EnableBillingServiceResponse>;
    /**
     * @generated from protobuf rpc: DisableBillingService(viam.app.v1.DisableBillingServiceRequest) returns (viam.app.v1.DisableBillingServiceResponse);
     */
    disableBillingService(input: DisableBillingServiceRequest, options?: RpcOptions): UnaryCall<DisableBillingServiceRequest, DisableBillingServiceResponse>;
    /**
     * @generated from protobuf rpc: UpdateBillingService(viam.app.v1.UpdateBillingServiceRequest) returns (viam.app.v1.UpdateBillingServiceResponse);
     */
    updateBillingService(input: UpdateBillingServiceRequest, options?: RpcOptions): UnaryCall<UpdateBillingServiceRequest, UpdateBillingServiceResponse>;
    /**
     * @generated from protobuf rpc: GetBillingServiceConfig(viam.app.v1.GetBillingServiceConfigRequest) returns (viam.app.v1.GetBillingServiceConfigResponse);
     */
    getBillingServiceConfig(input: GetBillingServiceConfigRequest, options?: RpcOptions): UnaryCall<GetBillingServiceConfigRequest, GetBillingServiceConfigResponse>;
    /**
     * @generated from protobuf rpc: OrganizationSetSupportEmail(viam.app.v1.OrganizationSetSupportEmailRequest) returns (viam.app.v1.OrganizationSetSupportEmailResponse);
     */
    organizationSetSupportEmail(input: OrganizationSetSupportEmailRequest, options?: RpcOptions): UnaryCall<OrganizationSetSupportEmailRequest, OrganizationSetSupportEmailResponse>;
    /**
     * @generated from protobuf rpc: OrganizationGetSupportEmail(viam.app.v1.OrganizationGetSupportEmailRequest) returns (viam.app.v1.OrganizationGetSupportEmailResponse);
     */
    organizationGetSupportEmail(input: OrganizationGetSupportEmailRequest, options?: RpcOptions): UnaryCall<OrganizationGetSupportEmailRequest, OrganizationGetSupportEmailResponse>;
    /**
     * @generated from protobuf rpc: OrganizationSetLogo(viam.app.v1.OrganizationSetLogoRequest) returns (viam.app.v1.OrganizationSetLogoResponse);
     */
    organizationSetLogo(input: OrganizationSetLogoRequest, options?: RpcOptions): UnaryCall<OrganizationSetLogoRequest, OrganizationSetLogoResponse>;
    /**
     * @generated from protobuf rpc: OrganizationGetLogo(viam.app.v1.OrganizationGetLogoRequest) returns (viam.app.v1.OrganizationGetLogoResponse);
     */
    organizationGetLogo(input: OrganizationGetLogoRequest, options?: RpcOptions): UnaryCall<OrganizationGetLogoRequest, OrganizationGetLogoResponse>;
    /**
     * @generated from protobuf rpc: EnableAuthService(viam.app.v1.EnableAuthServiceRequest) returns (viam.app.v1.EnableAuthServiceResponse);
     */
    enableAuthService(input: EnableAuthServiceRequest, options?: RpcOptions): UnaryCall<EnableAuthServiceRequest, EnableAuthServiceResponse>;
    /**
     * @generated from protobuf rpc: DisableAuthService(viam.app.v1.DisableAuthServiceRequest) returns (viam.app.v1.DisableAuthServiceResponse);
     */
    disableAuthService(input: DisableAuthServiceRequest, options?: RpcOptions): UnaryCall<DisableAuthServiceRequest, DisableAuthServiceResponse>;
    /**
     * @generated from protobuf rpc: CreateOAuthApp(viam.app.v1.CreateOAuthAppRequest) returns (viam.app.v1.CreateOAuthAppResponse);
     */
    createOAuthApp(input: CreateOAuthAppRequest, options?: RpcOptions): UnaryCall<CreateOAuthAppRequest, CreateOAuthAppResponse>;
    /**
     * @generated from protobuf rpc: ReadOAuthApp(viam.app.v1.ReadOAuthAppRequest) returns (viam.app.v1.ReadOAuthAppResponse);
     */
    readOAuthApp(input: ReadOAuthAppRequest, options?: RpcOptions): UnaryCall<ReadOAuthAppRequest, ReadOAuthAppResponse>;
    /**
     * @generated from protobuf rpc: UpdateOAuthApp(viam.app.v1.UpdateOAuthAppRequest) returns (viam.app.v1.UpdateOAuthAppResponse);
     */
    updateOAuthApp(input: UpdateOAuthAppRequest, options?: RpcOptions): UnaryCall<UpdateOAuthAppRequest, UpdateOAuthAppResponse>;
    /**
     * @generated from protobuf rpc: DeleteOAuthApp(viam.app.v1.DeleteOAuthAppRequest) returns (viam.app.v1.DeleteOAuthAppResponse);
     */
    deleteOAuthApp(input: DeleteOAuthAppRequest, options?: RpcOptions): UnaryCall<DeleteOAuthAppRequest, DeleteOAuthAppResponse>;
    /**
     * @generated from protobuf rpc: ListOAuthApps(viam.app.v1.ListOAuthAppsRequest) returns (viam.app.v1.ListOAuthAppsResponse);
     */
    listOAuthApps(input: ListOAuthAppsRequest, options?: RpcOptions): UnaryCall<ListOAuthAppsRequest, ListOAuthAppsResponse>;
    /**
     * @generated from protobuf rpc: CreateOAuthAppUser(viam.app.v1.CreateOAuthAppUserRequest) returns (viam.app.v1.CreateOAuthAppUserResponse);
     */
    createOAuthAppUser(input: CreateOAuthAppUserRequest, options?: RpcOptions): UnaryCall<CreateOAuthAppUserRequest, CreateOAuthAppUserResponse>;
    // Location

    /**
     * Create a location
     *
     * @generated from protobuf rpc: CreateLocation(viam.app.v1.CreateLocationRequest) returns (viam.app.v1.CreateLocationResponse);
     */
    createLocation(input: CreateLocationRequest, options?: RpcOptions): UnaryCall<CreateLocationRequest, CreateLocationResponse>;
    /**
     * Get a location
     *
     * @generated from protobuf rpc: GetLocation(viam.app.v1.GetLocationRequest) returns (viam.app.v1.GetLocationResponse);
     */
    getLocation(input: GetLocationRequest, options?: RpcOptions): UnaryCall<GetLocationRequest, GetLocationResponse>;
    /**
     * Update a location
     *
     * @generated from protobuf rpc: UpdateLocation(viam.app.v1.UpdateLocationRequest) returns (viam.app.v1.UpdateLocationResponse);
     */
    updateLocation(input: UpdateLocationRequest, options?: RpcOptions): UnaryCall<UpdateLocationRequest, UpdateLocationResponse>;
    /**
     * Delete a location
     *
     * @generated from protobuf rpc: DeleteLocation(viam.app.v1.DeleteLocationRequest) returns (viam.app.v1.DeleteLocationResponse);
     */
    deleteLocation(input: DeleteLocationRequest, options?: RpcOptions): UnaryCall<DeleteLocationRequest, DeleteLocationResponse>;
    /**
     * Get user-defined metadata for a location
     *
     * @generated from protobuf rpc: GetLocationMetadata(viam.app.v1.GetLocationMetadataRequest) returns (viam.app.v1.GetLocationMetadataResponse);
     */
    getLocationMetadata(input: GetLocationMetadataRequest, options?: RpcOptions): UnaryCall<GetLocationMetadataRequest, GetLocationMetadataResponse>;
    /**
     * Update user-defined metadata for a location
     *
     * @generated from protobuf rpc: UpdateLocationMetadata(viam.app.v1.UpdateLocationMetadataRequest) returns (viam.app.v1.UpdateLocationMetadataResponse);
     */
    updateLocationMetadata(input: UpdateLocationMetadataRequest, options?: RpcOptions): UnaryCall<UpdateLocationMetadataRequest, UpdateLocationMetadataResponse>;
    /**
     * Get a list of locations
     *
     * @generated from protobuf rpc: ListLocations(viam.app.v1.ListLocationsRequest) returns (viam.app.v1.ListLocationsResponse);
     */
    listLocations(input: ListLocationsRequest, options?: RpcOptions): UnaryCall<ListLocationsRequest, ListLocationsResponse>;
    /**
     * Share a location with an organization
     *
     * @generated from protobuf rpc: ShareLocation(viam.app.v1.ShareLocationRequest) returns (viam.app.v1.ShareLocationResponse);
     */
    shareLocation(input: ShareLocationRequest, options?: RpcOptions): UnaryCall<ShareLocationRequest, ShareLocationResponse>;
    /**
     * Stop sharing a location with an organization
     *
     * @generated from protobuf rpc: UnshareLocation(viam.app.v1.UnshareLocationRequest) returns (viam.app.v1.UnshareLocationResponse);
     */
    unshareLocation(input: UnshareLocationRequest, options?: RpcOptions): UnaryCall<UnshareLocationRequest, UnshareLocationResponse>;
    /**
     * Get a location's authorization secrets
     *
     * @generated from protobuf rpc: LocationAuth(viam.app.v1.LocationAuthRequest) returns (viam.app.v1.LocationAuthResponse);
     */
    locationAuth(input: LocationAuthRequest, options?: RpcOptions): UnaryCall<LocationAuthRequest, LocationAuthResponse>;
    /**
     * Create a new generated Secret in the Location.
     *  - Succeeds if there are no more than 2 active secrets after creation.
     *
     * @generated from protobuf rpc: CreateLocationSecret(viam.app.v1.CreateLocationSecretRequest) returns (viam.app.v1.CreateLocationSecretResponse);
     */
    createLocationSecret(input: CreateLocationSecretRequest, options?: RpcOptions): UnaryCall<CreateLocationSecretRequest, CreateLocationSecretResponse>;
    /**
     * Delete a Secret from the Location.
     *
     * @generated from protobuf rpc: DeleteLocationSecret(viam.app.v1.DeleteLocationSecretRequest) returns (viam.app.v1.DeleteLocationSecretResponse);
     */
    deleteLocationSecret(input: DeleteLocationSecretRequest, options?: RpcOptions): UnaryCall<DeleteLocationSecretRequest, DeleteLocationSecretResponse>;
    /**
     * Get a specific robot by ID
     *
     * @generated from protobuf rpc: GetRobot(viam.app.v1.GetRobotRequest) returns (viam.app.v1.GetRobotResponse);
     */
    getRobot(input: GetRobotRequest, options?: RpcOptions): UnaryCall<GetRobotRequest, GetRobotResponse>;
    /**
     * Get user-defined metadata for a robot
     *
     * @generated from protobuf rpc: GetRobotMetadata(viam.app.v1.GetRobotMetadataRequest) returns (viam.app.v1.GetRobotMetadataResponse);
     */
    getRobotMetadata(input: GetRobotMetadataRequest, options?: RpcOptions): UnaryCall<GetRobotMetadataRequest, GetRobotMetadataResponse>;
    /**
     * Update user-defined metadata for an robot
     *
     * @generated from protobuf rpc: UpdateRobotMetadata(viam.app.v1.UpdateRobotMetadataRequest) returns (viam.app.v1.UpdateRobotMetadataResponse);
     */
    updateRobotMetadata(input: UpdateRobotMetadataRequest, options?: RpcOptions): UnaryCall<UpdateRobotMetadataRequest, UpdateRobotMetadataResponse>;
    /**
     * Get Rover Rental Location Robots
     *
     * @generated from protobuf rpc: GetRoverRentalRobots(viam.app.v1.GetRoverRentalRobotsRequest) returns (viam.app.v1.GetRoverRentalRobotsResponse);
     */
    getRoverRentalRobots(input: GetRoverRentalRobotsRequest, options?: RpcOptions): UnaryCall<GetRoverRentalRobotsRequest, GetRoverRentalRobotsResponse>;
    /**
     * @generated from protobuf rpc: GetRobotParts(viam.app.v1.GetRobotPartsRequest) returns (viam.app.v1.GetRobotPartsResponse);
     */
    getRobotParts(input: GetRobotPartsRequest, options?: RpcOptions): UnaryCall<GetRobotPartsRequest, GetRobotPartsResponse>;
    /**
     * Get a specific robot part by ID
     *
     * @generated from protobuf rpc: GetRobotPart(viam.app.v1.GetRobotPartRequest) returns (viam.app.v1.GetRobotPartResponse);
     */
    getRobotPart(input: GetRobotPartRequest, options?: RpcOptions): UnaryCall<GetRobotPartRequest, GetRobotPartResponse>;
    /**
     * Get a specific robot part by name and location
     *
     * @generated from protobuf rpc: GetRobotPartByNameAndLocation(viam.app.v1.GetRobotPartByNameAndLocationRequest) returns (viam.app.v1.GetRobotPartByNameAndLocationResponse);
     */
    getRobotPartByNameAndLocation(input: GetRobotPartByNameAndLocationRequest, options?: RpcOptions): UnaryCall<GetRobotPartByNameAndLocationRequest, GetRobotPartByNameAndLocationResponse>;
    /**
     * @generated from protobuf rpc: GetRobotPartLogs(viam.app.v1.GetRobotPartLogsRequest) returns (viam.app.v1.GetRobotPartLogsResponse);
     */
    getRobotPartLogs(input: GetRobotPartLogsRequest, options?: RpcOptions): UnaryCall<GetRobotPartLogsRequest, GetRobotPartLogsResponse>;
    /**
     * @generated from protobuf rpc: TailRobotPartLogs(viam.app.v1.TailRobotPartLogsRequest) returns (stream viam.app.v1.TailRobotPartLogsResponse);
     */
    tailRobotPartLogs(input: TailRobotPartLogsRequest, options?: RpcOptions): ServerStreamingCall<TailRobotPartLogsRequest, TailRobotPartLogsResponse>;
    /**
     * Get a specific robot part histy by ID
     *
     * @generated from protobuf rpc: GetRobotPartHistory(viam.app.v1.GetRobotPartHistoryRequest) returns (viam.app.v1.GetRobotPartHistoryResponse);
     */
    getRobotPartHistory(input: GetRobotPartHistoryRequest, options?: RpcOptions): UnaryCall<GetRobotPartHistoryRequest, GetRobotPartHistoryResponse>;
    /**
     * Update a robot
     *
     * @generated from protobuf rpc: UpdateRobotPart(viam.app.v1.UpdateRobotPartRequest) returns (viam.app.v1.UpdateRobotPartResponse);
     */
    updateRobotPart(input: UpdateRobotPartRequest, options?: RpcOptions): UnaryCall<UpdateRobotPartRequest, UpdateRobotPartResponse>;
    /**
     * Create a new robot part
     *
     * @generated from protobuf rpc: NewRobotPart(viam.app.v1.NewRobotPartRequest) returns (viam.app.v1.NewRobotPartResponse);
     */
    newRobotPart(input: NewRobotPartRequest, options?: RpcOptions): UnaryCall<NewRobotPartRequest, NewRobotPartResponse>;
    /**
     * Delete a robot part
     *
     * @generated from protobuf rpc: DeleteRobotPart(viam.app.v1.DeleteRobotPartRequest) returns (viam.app.v1.DeleteRobotPartResponse);
     */
    deleteRobotPart(input: DeleteRobotPartRequest, options?: RpcOptions): UnaryCall<DeleteRobotPartRequest, DeleteRobotPartResponse>;
    /**
     * Get user-defined metadata for a robot part
     *
     * @generated from protobuf rpc: GetRobotPartMetadata(viam.app.v1.GetRobotPartMetadataRequest) returns (viam.app.v1.GetRobotPartMetadataResponse);
     */
    getRobotPartMetadata(input: GetRobotPartMetadataRequest, options?: RpcOptions): UnaryCall<GetRobotPartMetadataRequest, GetRobotPartMetadataResponse>;
    /**
     * Update user-defined metadata for an robot part
     *
     * @generated from protobuf rpc: UpdateRobotPartMetadata(viam.app.v1.UpdateRobotPartMetadataRequest) returns (viam.app.v1.UpdateRobotPartMetadataResponse);
     */
    updateRobotPartMetadata(input: UpdateRobotPartMetadataRequest, options?: RpcOptions): UnaryCall<UpdateRobotPartMetadataRequest, UpdateRobotPartMetadataResponse>;
    /**
     * Gets the Robot API Keys for the robot
     *
     * @generated from protobuf rpc: GetRobotAPIKeys(viam.app.v1.GetRobotAPIKeysRequest) returns (viam.app.v1.GetRobotAPIKeysResponse);
     */
    getRobotAPIKeys(input: GetRobotAPIKeysRequest, options?: RpcOptions): UnaryCall<GetRobotAPIKeysRequest, GetRobotAPIKeysResponse>;
    /**
     * Marks the given part as the main part, and all the others as not
     *
     * @generated from protobuf rpc: MarkPartAsMain(viam.app.v1.MarkPartAsMainRequest) returns (viam.app.v1.MarkPartAsMainResponse);
     */
    markPartAsMain(input: MarkPartAsMainRequest, options?: RpcOptions): UnaryCall<MarkPartAsMainRequest, MarkPartAsMainResponse>;
    /**
     * Marks part for restart. Once the robot part checks-in with the app the flag
     * is reset on the robot part. Calling this multiple times before a robot part
     * checks-in has no affect.
     * Note: This API may be removed in the near future.
     * TODO(APP-388): Remove
     *
     * @generated from protobuf rpc: MarkPartForRestart(viam.app.v1.MarkPartForRestartRequest) returns (viam.app.v1.MarkPartForRestartResponse);
     */
    markPartForRestart(input: MarkPartForRestartRequest, options?: RpcOptions): UnaryCall<MarkPartForRestartRequest, MarkPartForRestartResponse>;
    /**
     * Create a new generated Secret in the Robot Part.
     *  - Succeeds if there are no more than 2 active secrets after creation.
     *
     * @generated from protobuf rpc: CreateRobotPartSecret(viam.app.v1.CreateRobotPartSecretRequest) returns (viam.app.v1.CreateRobotPartSecretResponse);
     */
    createRobotPartSecret(input: CreateRobotPartSecretRequest, options?: RpcOptions): UnaryCall<CreateRobotPartSecretRequest, CreateRobotPartSecretResponse>;
    /**
     * Delete a Secret from the RobotPart.
     *
     * @generated from protobuf rpc: DeleteRobotPartSecret(viam.app.v1.DeleteRobotPartSecretRequest) returns (viam.app.v1.DeleteRobotPartSecretResponse);
     */
    deleteRobotPartSecret(input: DeleteRobotPartSecretRequest, options?: RpcOptions): UnaryCall<DeleteRobotPartSecretRequest, DeleteRobotPartSecretResponse>;
    /**
     * Get a list of robots at a location
     *
     * @generated from protobuf rpc: ListRobots(viam.app.v1.ListRobotsRequest) returns (viam.app.v1.ListRobotsResponse);
     */
    listRobots(input: ListRobotsRequest, options?: RpcOptions): UnaryCall<ListRobotsRequest, ListRobotsResponse>;
    /**
     * Get a list of robots at multiple locations
     *
     * @generated from protobuf rpc: ListRobotsForLocations(viam.app.v1.ListRobotsForLocationsRequest) returns (viam.app.v1.ListRobotsForLocationsResponse);
     */
    listRobotsForLocations(input: ListRobotsForLocationsRequest, options?: RpcOptions): UnaryCall<ListRobotsForLocationsRequest, ListRobotsForLocationsResponse>;
    /**
     * Get a list of robots at an org
     *
     * @generated from protobuf rpc: ListRobotsForOrg(viam.app.v1.ListRobotsForOrgRequest) returns (viam.app.v1.ListRobotsForOrgResponse);
     */
    listRobotsForOrg(input: ListRobotsForOrgRequest, options?: RpcOptions): UnaryCall<ListRobotsForOrgRequest, ListRobotsForOrgResponse>;
    /**
     * NewRobot creates a new robot
     *
     * @generated from protobuf rpc: NewRobot(viam.app.v1.NewRobotRequest) returns (viam.app.v1.NewRobotResponse);
     */
    newRobot(input: NewRobotRequest, options?: RpcOptions): UnaryCall<NewRobotRequest, NewRobotResponse>;
    /**
     * UpdateRobot updates a robot
     *
     * @generated from protobuf rpc: UpdateRobot(viam.app.v1.UpdateRobotRequest) returns (viam.app.v1.UpdateRobotResponse);
     */
    updateRobot(input: UpdateRobotRequest, options?: RpcOptions): UnaryCall<UpdateRobotRequest, UpdateRobotResponse>;
    /**
     * DeleteRobot deletes a robot
     *
     * @generated from protobuf rpc: DeleteRobot(viam.app.v1.DeleteRobotRequest) returns (viam.app.v1.DeleteRobotResponse);
     */
    deleteRobot(input: DeleteRobotRequest, options?: RpcOptions): UnaryCall<DeleteRobotRequest, DeleteRobotResponse>;
    // Fragments

    /**
     * Gets a list of fragments
     *
     * @generated from protobuf rpc: ListFragments(viam.app.v1.ListFragmentsRequest) returns (viam.app.v1.ListFragmentsResponse);
     */
    listFragments(input: ListFragmentsRequest, options?: RpcOptions): UnaryCall<ListFragmentsRequest, ListFragmentsResponse>;
    /**
     * Gets a single fragment
     *
     * @generated from protobuf rpc: GetFragment(viam.app.v1.GetFragmentRequest) returns (viam.app.v1.GetFragmentResponse);
     */
    getFragment(input: GetFragmentRequest, options?: RpcOptions): UnaryCall<GetFragmentRequest, GetFragmentResponse>;
    /**
     * Creates a fragment
     *
     * @generated from protobuf rpc: CreateFragment(viam.app.v1.CreateFragmentRequest) returns (viam.app.v1.CreateFragmentResponse);
     */
    createFragment(input: CreateFragmentRequest, options?: RpcOptions): UnaryCall<CreateFragmentRequest, CreateFragmentResponse>;
    /**
     * Updates a fragment
     *
     * @generated from protobuf rpc: UpdateFragment(viam.app.v1.UpdateFragmentRequest) returns (viam.app.v1.UpdateFragmentResponse);
     */
    updateFragment(input: UpdateFragmentRequest, options?: RpcOptions): UnaryCall<UpdateFragmentRequest, UpdateFragmentResponse>;
    /**
     * Deletes a fragment
     *
     * @generated from protobuf rpc: DeleteFragment(viam.app.v1.DeleteFragmentRequest) returns (viam.app.v1.DeleteFragmentResponse);
     */
    deleteFragment(input: DeleteFragmentRequest, options?: RpcOptions): UnaryCall<DeleteFragmentRequest, DeleteFragmentResponse>;
    /**
     * List nested fragments for a fragment
     *
     * @generated from protobuf rpc: ListNestedFragments(viam.app.v1.ListNestedFragmentsRequest) returns (viam.app.v1.ListNestedFragmentsResponse);
     */
    listNestedFragments(input: ListNestedFragmentsRequest, options?: RpcOptions): UnaryCall<ListNestedFragmentsRequest, ListNestedFragmentsResponse>;
    /**
     * Gets top level and nested fragments for a machine, as well as any other specified fragment ids
     *
     * @generated from protobuf rpc: ListMachineFragments(viam.app.v1.ListMachineFragmentsRequest) returns (viam.app.v1.ListMachineFragmentsResponse);
     */
    listMachineFragments(input: ListMachineFragmentsRequest, options?: RpcOptions): UnaryCall<ListMachineFragmentsRequest, ListMachineFragmentsResponse>;
    /**
     * List all machines and their corresponding machine dashboard information
     *
     * @generated from protobuf rpc: ListMachineSummaries(viam.app.v1.ListMachineSummariesRequest) returns (viam.app.v1.ListMachineSummariesResponse);
     */
    listMachineSummaries(input: ListMachineSummariesRequest, options?: RpcOptions): UnaryCall<ListMachineSummariesRequest, ListMachineSummariesResponse>;
    /**
     * Gets fragment history
     *
     * @generated from protobuf rpc: GetFragmentHistory(viam.app.v1.GetFragmentHistoryRequest) returns (viam.app.v1.GetFragmentHistoryResponse);
     */
    getFragmentHistory(input: GetFragmentHistoryRequest, options?: RpcOptions): UnaryCall<GetFragmentHistoryRequest, GetFragmentHistoryResponse>;
    /**
     * Gets usage for a fragment across versions
     *
     * @generated from protobuf rpc: GetFragmentUsage(viam.app.v1.GetFragmentUsageRequest) returns (viam.app.v1.GetFragmentUsageResponse);
     */
    getFragmentUsage(input: GetFragmentUsageRequest, options?: RpcOptions): UnaryCall<GetFragmentUsageRequest, GetFragmentUsageResponse>;
    /**
     * Sets a fragment tag to a revision
     *
     * @generated from protobuf rpc: SetFragmentTag(viam.app.v1.SetFragmentTagRequest) returns (viam.app.v1.SetFragmentTagResponse);
     */
    setFragmentTag(input: SetFragmentTagRequest, options?: RpcOptions): UnaryCall<SetFragmentTagRequest, SetFragmentTagResponse>;
    /**
     * Deletes a fragment tag
     *
     * @generated from protobuf rpc: DeleteFragmentTag(viam.app.v1.DeleteFragmentTagRequest) returns (viam.app.v1.DeleteFragmentTagResponse);
     */
    deleteFragmentTag(input: DeleteFragmentTagRequest, options?: RpcOptions): UnaryCall<DeleteFragmentTagRequest, DeleteFragmentTagResponse>;
    /**
     * Creates an IdentityAuthorization
     *
     * @generated from protobuf rpc: AddRole(viam.app.v1.AddRoleRequest) returns (viam.app.v1.AddRoleResponse);
     */
    addRole(input: AddRoleRequest, options?: RpcOptions): UnaryCall<AddRoleRequest, AddRoleResponse>;
    /**
     * Deletes an IdentityAuthorization
     *
     * @generated from protobuf rpc: RemoveRole(viam.app.v1.RemoveRoleRequest) returns (viam.app.v1.RemoveRoleResponse);
     */
    removeRole(input: RemoveRoleRequest, options?: RpcOptions): UnaryCall<RemoveRoleRequest, RemoveRoleResponse>;
    /**
     * Changes an IdentityAuthorization to a new IdentityAuthorization
     *
     * @generated from protobuf rpc: ChangeRole(viam.app.v1.ChangeRoleRequest) returns (viam.app.v1.ChangeRoleResponse);
     */
    changeRole(input: ChangeRoleRequest, options?: RpcOptions): UnaryCall<ChangeRoleRequest, ChangeRoleResponse>;
    /**
     * Returns all authorization roles for a given resource
     *
     * @generated from protobuf rpc: ListAuthorizations(viam.app.v1.ListAuthorizationsRequest) returns (viam.app.v1.ListAuthorizationsResponse);
     */
    listAuthorizations(input: ListAuthorizationsRequest, options?: RpcOptions): UnaryCall<ListAuthorizationsRequest, ListAuthorizationsResponse>;
    /**
     * Validates a permission for the current user
     *
     * @generated from protobuf rpc: CheckPermissions(viam.app.v1.CheckPermissionsRequest) returns (viam.app.v1.CheckPermissionsResponse);
     */
    checkPermissions(input: CheckPermissionsRequest, options?: RpcOptions): UnaryCall<CheckPermissionsRequest, CheckPermissionsResponse>;
    /**
     * @generated from protobuf rpc: GetRegistryItem(viam.app.v1.GetRegistryItemRequest) returns (viam.app.v1.GetRegistryItemResponse);
     */
    getRegistryItem(input: GetRegistryItemRequest, options?: RpcOptions): UnaryCall<GetRegistryItemRequest, GetRegistryItemResponse>;
    /**
     * @generated from protobuf rpc: CreateRegistryItem(viam.app.v1.CreateRegistryItemRequest) returns (viam.app.v1.CreateRegistryItemResponse);
     */
    createRegistryItem(input: CreateRegistryItemRequest, options?: RpcOptions): UnaryCall<CreateRegistryItemRequest, CreateRegistryItemResponse>;
    /**
     * @generated from protobuf rpc: UpdateRegistryItem(viam.app.v1.UpdateRegistryItemRequest) returns (viam.app.v1.UpdateRegistryItemResponse);
     */
    updateRegistryItem(input: UpdateRegistryItemRequest, options?: RpcOptions): UnaryCall<UpdateRegistryItemRequest, UpdateRegistryItemResponse>;
    /**
     * @generated from protobuf rpc: ListRegistryItems(viam.app.v1.ListRegistryItemsRequest) returns (viam.app.v1.ListRegistryItemsResponse);
     */
    listRegistryItems(input: ListRegistryItemsRequest, options?: RpcOptions): UnaryCall<ListRegistryItemsRequest, ListRegistryItemsResponse>;
    /**
     * @generated from protobuf rpc: DeleteRegistryItem(viam.app.v1.DeleteRegistryItemRequest) returns (viam.app.v1.DeleteRegistryItemResponse);
     */
    deleteRegistryItem(input: DeleteRegistryItemRequest, options?: RpcOptions): UnaryCall<DeleteRegistryItemRequest, DeleteRegistryItemResponse>;
    /**
     * @generated from protobuf rpc: RenameRegistryItem(viam.app.v1.RenameRegistryItemRequest) returns (viam.app.v1.RenameRegistryItemResponse);
     */
    renameRegistryItem(input: RenameRegistryItemRequest, options?: RpcOptions): UnaryCall<RenameRegistryItemRequest, RenameRegistryItemResponse>;
    /**
     * @generated from protobuf rpc: TransferRegistryItem(viam.app.v1.TransferRegistryItemRequest) returns (viam.app.v1.TransferRegistryItemResponse);
     */
    transferRegistryItem(input: TransferRegistryItemRequest, options?: RpcOptions): UnaryCall<TransferRegistryItemRequest, TransferRegistryItemResponse>;
    /**
     * @generated from protobuf rpc: DeprecateRegistryItem(viam.app.v1.DeprecateRegistryItemRequest) returns (viam.app.v1.DeprecateRegistryItemResponse);
     */
    deprecateRegistryItem(input: DeprecateRegistryItemRequest, options?: RpcOptions): UnaryCall<DeprecateRegistryItemRequest, DeprecateRegistryItemResponse>;
    /**
     * @generated from protobuf rpc: UndeprecateRegistryItem(viam.app.v1.UndeprecateRegistryItemRequest) returns (viam.app.v1.UndeprecateRegistryItemResponse);
     */
    undeprecateRegistryItem(input: UndeprecateRegistryItemRequest, options?: RpcOptions): UnaryCall<UndeprecateRegistryItemRequest, UndeprecateRegistryItemResponse>;
    /**
     * @generated from protobuf rpc: CreateModule(viam.app.v1.CreateModuleRequest) returns (viam.app.v1.CreateModuleResponse);
     */
    createModule(input: CreateModuleRequest, options?: RpcOptions): UnaryCall<CreateModuleRequest, CreateModuleResponse>;
    /**
     * @generated from protobuf rpc: UpdateModule(viam.app.v1.UpdateModuleRequest) returns (viam.app.v1.UpdateModuleResponse);
     */
    updateModule(input: UpdateModuleRequest, options?: RpcOptions): UnaryCall<UpdateModuleRequest, UpdateModuleResponse>;
    /**
     * @generated from protobuf rpc: UploadModuleFile(stream viam.app.v1.UploadModuleFileRequest) returns (viam.app.v1.UploadModuleFileResponse);
     */
    uploadModuleFile(options?: RpcOptions): ClientStreamingCall<UploadModuleFileRequest, UploadModuleFileResponse>;
    /**
     * @generated from protobuf rpc: GetModule(viam.app.v1.GetModuleRequest) returns (viam.app.v1.GetModuleResponse);
     */
    getModule(input: GetModuleRequest, options?: RpcOptions): UnaryCall<GetModuleRequest, GetModuleResponse>;
    /**
     * @generated from protobuf rpc: ListModules(viam.app.v1.ListModulesRequest) returns (viam.app.v1.ListModulesResponse);
     */
    listModules(input: ListModulesRequest, options?: RpcOptions): UnaryCall<ListModulesRequest, ListModulesResponse>;
    /**
     * @generated from protobuf rpc: DeprecateRegistryItemVersion(viam.app.v1.DeprecateRegistryItemVersionRequest) returns (viam.app.v1.DeprecateRegistryItemVersionResponse);
     */
    deprecateRegistryItemVersion(input: DeprecateRegistryItemVersionRequest, options?: RpcOptions): UnaryCall<DeprecateRegistryItemVersionRequest, DeprecateRegistryItemVersionResponse>;
    /**
     * @generated from protobuf rpc: UndeprecateRegistryItemVersion(viam.app.v1.UndeprecateRegistryItemVersionRequest) returns (viam.app.v1.UndeprecateRegistryItemVersionResponse);
     */
    undeprecateRegistryItemVersion(input: UndeprecateRegistryItemVersionRequest, options?: RpcOptions): UnaryCall<UndeprecateRegistryItemVersionRequest, UndeprecateRegistryItemVersionResponse>;
    /**
     * @generated from protobuf rpc: CreateKey(viam.app.v1.CreateKeyRequest) returns (viam.app.v1.CreateKeyResponse);
     */
    createKey(input: CreateKeyRequest, options?: RpcOptions): UnaryCall<CreateKeyRequest, CreateKeyResponse>;
    /**
     * @generated from protobuf rpc: DeleteKey(viam.app.v1.DeleteKeyRequest) returns (viam.app.v1.DeleteKeyResponse);
     */
    deleteKey(input: DeleteKeyRequest, options?: RpcOptions): UnaryCall<DeleteKeyRequest, DeleteKeyResponse>;
    /**
     * @generated from protobuf rpc: ListKeys(viam.app.v1.ListKeysRequest) returns (viam.app.v1.ListKeysResponse);
     */
    listKeys(input: ListKeysRequest, options?: RpcOptions): UnaryCall<ListKeysRequest, ListKeysResponse>;
    /**
     * @generated from protobuf rpc: RenameKey(viam.app.v1.RenameKeyRequest) returns (viam.app.v1.RenameKeyResponse);
     */
    renameKey(input: RenameKeyRequest, options?: RpcOptions): UnaryCall<RenameKeyRequest, RenameKeyResponse>;
    /**
     * @generated from protobuf rpc: RotateKey(viam.app.v1.RotateKeyRequest) returns (viam.app.v1.RotateKeyResponse);
     */
    rotateKey(input: RotateKeyRequest, options?: RpcOptions): UnaryCall<RotateKeyRequest, RotateKeyResponse>;
    /**
     * @generated from protobuf rpc: CreateKeyFromExistingKeyAuthorizations(viam.app.v1.CreateKeyFromExistingKeyAuthorizationsRequest) returns (viam.app.v1.CreateKeyFromExistingKeyAuthorizationsResponse);
     */
    createKeyFromExistingKeyAuthorizations(input: CreateKeyFromExistingKeyAuthorizationsRequest, options?: RpcOptions): UnaryCall<CreateKeyFromExistingKeyAuthorizationsRequest, CreateKeyFromExistingKeyAuthorizationsResponse>;
    /**
     * @generated from protobuf rpc: GetAppContent(viam.app.v1.GetAppContentRequest) returns (viam.app.v1.GetAppContentResponse);
     */
    getAppContent(input: GetAppContentRequest, options?: RpcOptions): UnaryCall<GetAppContentRequest, GetAppContentResponse>;
    /**
     * @generated from protobuf rpc: GetAppBranding(viam.app.v1.GetAppBrandingRequest) returns (viam.app.v1.GetAppBrandingResponse);
     */
    getAppBranding(input: GetAppBrandingRequest, options?: RpcOptions): UnaryCall<GetAppBrandingRequest, GetAppBrandingResponse>;
    /**
     * Upload a device push token for the user.
     *
     * @generated from protobuf rpc: UploadDevicePushToken(viam.app.v1.UploadDevicePushTokenRequest) returns (viam.app.v1.UploadDevicePushTokenResponse);
     */
    uploadDevicePushToken(input: UploadDevicePushTokenRequest, options?: RpcOptions): UnaryCall<UploadDevicePushTokenRequest, UploadDevicePushTokenResponse>;
    /**
     * Delete a device push token for the user.
     *
     * @generated from protobuf rpc: DeleteDevicePushToken(viam.app.v1.DeleteDevicePushTokenRequest) returns (viam.app.v1.DeleteDevicePushTokenResponse);
     */
    deleteDevicePushToken(input: DeleteDevicePushTokenRequest, options?: RpcOptions): UnaryCall<DeleteDevicePushTokenRequest, DeleteDevicePushTokenResponse>;
    /**
     * Gets all device push tokens for the user for the given app ID.
     *
     * @generated from protobuf rpc: GetDevicePushTokens(viam.app.v1.GetDevicePushTokensRequest) returns (viam.app.v1.GetDevicePushTokensResponse);
     */
    getDevicePushTokens(input: GetDevicePushTokensRequest, options?: RpcOptions): UnaryCall<GetDevicePushTokensRequest, GetDevicePushTokensResponse>;
    /**
     * Set the Firebase config JSON for a specific app id.
     *
     * @generated from protobuf rpc: SetFirebaseConfig(viam.app.v1.SetFirebaseConfigRequest) returns (viam.app.v1.SetFirebaseConfigResponse);
     */
    setFirebaseConfig(input: SetFirebaseConfigRequest, options?: RpcOptions): UnaryCall<SetFirebaseConfigRequest, SetFirebaseConfigResponse>;
    /**
     * Read the app ID for an organization.
     * This returns only the app_id configured for the org, not the Firebase config JSON.
     *
     * @generated from protobuf rpc: GetFirebaseConfig(viam.app.v1.GetFirebaseConfigRequest) returns (viam.app.v1.GetFirebaseConfigResponse);
     */
    getFirebaseConfig(input: GetFirebaseConfigRequest, options?: RpcOptions): UnaryCall<GetFirebaseConfigRequest, GetFirebaseConfigResponse>;
    /**
     * Deletes a Firebase config JSON for a specific app id.
     *
     * @generated from protobuf rpc: DeleteFirebaseConfig(viam.app.v1.DeleteFirebaseConfigRequest) returns (viam.app.v1.DeleteFirebaseConfigResponse);
     */
    deleteFirebaseConfig(input: DeleteFirebaseConfigRequest, options?: RpcOptions): UnaryCall<DeleteFirebaseConfigRequest, DeleteFirebaseConfigResponse>;
}
/**
 * Users
 *
 * @generated from protobuf service viam.app.v1.AppService
 */
export class AppServiceClient implements IAppServiceClient, ServiceInfo {
    typeName = AppService.typeName;
    methods = AppService.methods;
    options = AppService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Get the id of the user with the email
     *
     * @generated from protobuf rpc: GetUserIDByEmail(viam.app.v1.GetUserIDByEmailRequest) returns (viam.app.v1.GetUserIDByEmailResponse);
     */
    getUserIDByEmail(input: GetUserIDByEmailRequest, options?: RpcOptions): UnaryCall<GetUserIDByEmailRequest, GetUserIDByEmailResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetUserIDByEmailRequest, GetUserIDByEmailResponse>("unary", this._transport, method, opt, input);
    }
    // Organizations

    /**
     * Create a new organization
     *
     * @generated from protobuf rpc: CreateOrganization(viam.app.v1.CreateOrganizationRequest) returns (viam.app.v1.CreateOrganizationResponse);
     */
    createOrganization(input: CreateOrganizationRequest, options?: RpcOptions): UnaryCall<CreateOrganizationRequest, CreateOrganizationResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrganizationRequest, CreateOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List organizations
     *
     * @generated from protobuf rpc: ListOrganizations(viam.app.v1.ListOrganizationsRequest) returns (viam.app.v1.ListOrganizationsResponse);
     */
    listOrganizations(input: ListOrganizationsRequest, options?: RpcOptions): UnaryCall<ListOrganizationsRequest, ListOrganizationsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListOrganizationsRequest, ListOrganizationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get all organizations that have access to a location.
     *
     * @generated from protobuf rpc: GetOrganizationsWithAccessToLocation(viam.app.v1.GetOrganizationsWithAccessToLocationRequest) returns (viam.app.v1.GetOrganizationsWithAccessToLocationResponse);
     */
    getOrganizationsWithAccessToLocation(input: GetOrganizationsWithAccessToLocationRequest, options?: RpcOptions): UnaryCall<GetOrganizationsWithAccessToLocationRequest, GetOrganizationsWithAccessToLocationResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationsWithAccessToLocationRequest, GetOrganizationsWithAccessToLocationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List the organizations a user belongs to
     *
     * @generated from protobuf rpc: ListOrganizationsByUser(viam.app.v1.ListOrganizationsByUserRequest) returns (viam.app.v1.ListOrganizationsByUserResponse);
     */
    listOrganizationsByUser(input: ListOrganizationsByUserRequest, options?: RpcOptions): UnaryCall<ListOrganizationsByUserRequest, ListOrganizationsByUserResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListOrganizationsByUserRequest, ListOrganizationsByUserResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Search organizations by a couple fields
     *
     * @generated from protobuf rpc: SearchOrganizations(viam.app.v1.SearchOrganizationsRequest) returns (viam.app.v1.SearchOrganizationsResponse);
     */
    searchOrganizations(input: SearchOrganizationsRequest, options?: RpcOptions): UnaryCall<SearchOrganizationsRequest, SearchOrganizationsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchOrganizationsRequest, SearchOrganizationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get an organization
     *
     * @generated from protobuf rpc: GetOrganization(viam.app.v1.GetOrganizationRequest) returns (viam.app.v1.GetOrganizationResponse);
     */
    getOrganization(input: GetOrganizationRequest, options?: RpcOptions): UnaryCall<GetOrganizationRequest, GetOrganizationResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationRequest, GetOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Checks for namespace availablity throughout all orgs.
     *
     * @generated from protobuf rpc: GetOrganizationNamespaceAvailability(viam.app.v1.GetOrganizationNamespaceAvailabilityRequest) returns (viam.app.v1.GetOrganizationNamespaceAvailabilityResponse);
     */
    getOrganizationNamespaceAvailability(input: GetOrganizationNamespaceAvailabilityRequest, options?: RpcOptions): UnaryCall<GetOrganizationNamespaceAvailabilityRequest, GetOrganizationNamespaceAvailabilityResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationNamespaceAvailabilityRequest, GetOrganizationNamespaceAvailabilityResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update an organization
     *
     * @generated from protobuf rpc: UpdateOrganization(viam.app.v1.UpdateOrganizationRequest) returns (viam.app.v1.UpdateOrganizationResponse);
     */
    updateOrganization(input: UpdateOrganizationRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationRequest, UpdateOrganizationResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateOrganizationRequest, UpdateOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update an organization's namespace if it's already been set.
     *
     * @generated from protobuf rpc: UpdateOrganizationNamespace(viam.app.v1.UpdateOrganizationNamespaceRequest) returns (viam.app.v1.UpdateOrganizationNamespaceResponse);
     */
    updateOrganizationNamespace(input: UpdateOrganizationNamespaceRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationNamespaceRequest, UpdateOrganizationNamespaceResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateOrganizationNamespaceRequest, UpdateOrganizationNamespaceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete an organization
     *
     * @generated from protobuf rpc: DeleteOrganization(viam.app.v1.DeleteOrganizationRequest) returns (viam.app.v1.DeleteOrganizationResponse);
     */
    deleteOrganization(input: DeleteOrganizationRequest, options?: RpcOptions): UnaryCall<DeleteOrganizationRequest, DeleteOrganizationResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteOrganizationRequest, DeleteOrganizationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get user-defined metadata for an organization
     *
     * @generated from protobuf rpc: GetOrganizationMetadata(viam.app.v1.GetOrganizationMetadataRequest) returns (viam.app.v1.GetOrganizationMetadataResponse);
     */
    getOrganizationMetadata(input: GetOrganizationMetadataRequest, options?: RpcOptions): UnaryCall<GetOrganizationMetadataRequest, GetOrganizationMetadataResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOrganizationMetadataRequest, GetOrganizationMetadataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update user-defined metadata for an organization
     *
     * @generated from protobuf rpc: UpdateOrganizationMetadata(viam.app.v1.UpdateOrganizationMetadataRequest) returns (viam.app.v1.UpdateOrganizationMetadataResponse);
     */
    updateOrganizationMetadata(input: UpdateOrganizationMetadataRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationMetadataRequest, UpdateOrganizationMetadataResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateOrganizationMetadataRequest, UpdateOrganizationMetadataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List all members of an organization and all invited members to the organization.
     *
     * @generated from protobuf rpc: ListOrganizationMembers(viam.app.v1.ListOrganizationMembersRequest) returns (viam.app.v1.ListOrganizationMembersResponse);
     */
    listOrganizationMembers(input: ListOrganizationMembersRequest, options?: RpcOptions): UnaryCall<ListOrganizationMembersRequest, ListOrganizationMembersResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListOrganizationMembersRequest, ListOrganizationMembersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create an organization invite to an organization
     *
     * @generated from protobuf rpc: CreateOrganizationInvite(viam.app.v1.CreateOrganizationInviteRequest) returns (viam.app.v1.CreateOrganizationInviteResponse);
     */
    createOrganizationInvite(input: CreateOrganizationInviteRequest, options?: RpcOptions): UnaryCall<CreateOrganizationInviteRequest, CreateOrganizationInviteResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrganizationInviteRequest, CreateOrganizationInviteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update the authorizations attached to an organization invite
     *
     * @generated from protobuf rpc: UpdateOrganizationInviteAuthorizations(viam.app.v1.UpdateOrganizationInviteAuthorizationsRequest) returns (viam.app.v1.UpdateOrganizationInviteAuthorizationsResponse);
     */
    updateOrganizationInviteAuthorizations(input: UpdateOrganizationInviteAuthorizationsRequest, options?: RpcOptions): UnaryCall<UpdateOrganizationInviteAuthorizationsRequest, UpdateOrganizationInviteAuthorizationsResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateOrganizationInviteAuthorizationsRequest, UpdateOrganizationInviteAuthorizationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete an organization member from an organization
     *
     * @generated from protobuf rpc: DeleteOrganizationMember(viam.app.v1.DeleteOrganizationMemberRequest) returns (viam.app.v1.DeleteOrganizationMemberResponse);
     */
    deleteOrganizationMember(input: DeleteOrganizationMemberRequest, options?: RpcOptions): UnaryCall<DeleteOrganizationMemberRequest, DeleteOrganizationMemberResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteOrganizationMemberRequest, DeleteOrganizationMemberResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete an organization invite
     *
     * @generated from protobuf rpc: DeleteOrganizationInvite(viam.app.v1.DeleteOrganizationInviteRequest) returns (viam.app.v1.DeleteOrganizationInviteResponse);
     */
    deleteOrganizationInvite(input: DeleteOrganizationInviteRequest, options?: RpcOptions): UnaryCall<DeleteOrganizationInviteRequest, DeleteOrganizationInviteResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteOrganizationInviteRequest, DeleteOrganizationInviteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Resend an organization invite
     *
     * @generated from protobuf rpc: ResendOrganizationInvite(viam.app.v1.ResendOrganizationInviteRequest) returns (viam.app.v1.ResendOrganizationInviteResponse);
     */
    resendOrganizationInvite(input: ResendOrganizationInviteRequest, options?: RpcOptions): UnaryCall<ResendOrganizationInviteRequest, ResendOrganizationInviteResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<ResendOrganizationInviteRequest, ResendOrganizationInviteResponse>("unary", this._transport, method, opt, input);
    }
    // Third party

    /**
     * @generated from protobuf rpc: EnableBillingService(viam.app.v1.EnableBillingServiceRequest) returns (viam.app.v1.EnableBillingServiceResponse);
     */
    enableBillingService(input: EnableBillingServiceRequest, options?: RpcOptions): UnaryCall<EnableBillingServiceRequest, EnableBillingServiceResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<EnableBillingServiceRequest, EnableBillingServiceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DisableBillingService(viam.app.v1.DisableBillingServiceRequest) returns (viam.app.v1.DisableBillingServiceResponse);
     */
    disableBillingService(input: DisableBillingServiceRequest, options?: RpcOptions): UnaryCall<DisableBillingServiceRequest, DisableBillingServiceResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<DisableBillingServiceRequest, DisableBillingServiceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateBillingService(viam.app.v1.UpdateBillingServiceRequest) returns (viam.app.v1.UpdateBillingServiceResponse);
     */
    updateBillingService(input: UpdateBillingServiceRequest, options?: RpcOptions): UnaryCall<UpdateBillingServiceRequest, UpdateBillingServiceResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateBillingServiceRequest, UpdateBillingServiceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBillingServiceConfig(viam.app.v1.GetBillingServiceConfigRequest) returns (viam.app.v1.GetBillingServiceConfigResponse);
     */
    getBillingServiceConfig(input: GetBillingServiceConfigRequest, options?: RpcOptions): UnaryCall<GetBillingServiceConfigRequest, GetBillingServiceConfigResponse> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetBillingServiceConfigRequest, GetBillingServiceConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: OrganizationSetSupportEmail(viam.app.v1.OrganizationSetSupportEmailRequest) returns (viam.app.v1.OrganizationSetSupportEmailResponse);
     */
    organizationSetSupportEmail(input: OrganizationSetSupportEmailRequest, options?: RpcOptions): UnaryCall<OrganizationSetSupportEmailRequest, OrganizationSetSupportEmailResponse> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<OrganizationSetSupportEmailRequest, OrganizationSetSupportEmailResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: OrganizationGetSupportEmail(viam.app.v1.OrganizationGetSupportEmailRequest) returns (viam.app.v1.OrganizationGetSupportEmailResponse);
     */
    organizationGetSupportEmail(input: OrganizationGetSupportEmailRequest, options?: RpcOptions): UnaryCall<OrganizationGetSupportEmailRequest, OrganizationGetSupportEmailResponse> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<OrganizationGetSupportEmailRequest, OrganizationGetSupportEmailResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: OrganizationSetLogo(viam.app.v1.OrganizationSetLogoRequest) returns (viam.app.v1.OrganizationSetLogoResponse);
     */
    organizationSetLogo(input: OrganizationSetLogoRequest, options?: RpcOptions): UnaryCall<OrganizationSetLogoRequest, OrganizationSetLogoResponse> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<OrganizationSetLogoRequest, OrganizationSetLogoResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: OrganizationGetLogo(viam.app.v1.OrganizationGetLogoRequest) returns (viam.app.v1.OrganizationGetLogoResponse);
     */
    organizationGetLogo(input: OrganizationGetLogoRequest, options?: RpcOptions): UnaryCall<OrganizationGetLogoRequest, OrganizationGetLogoResponse> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<OrganizationGetLogoRequest, OrganizationGetLogoResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EnableAuthService(viam.app.v1.EnableAuthServiceRequest) returns (viam.app.v1.EnableAuthServiceResponse);
     */
    enableAuthService(input: EnableAuthServiceRequest, options?: RpcOptions): UnaryCall<EnableAuthServiceRequest, EnableAuthServiceResponse> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<EnableAuthServiceRequest, EnableAuthServiceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DisableAuthService(viam.app.v1.DisableAuthServiceRequest) returns (viam.app.v1.DisableAuthServiceResponse);
     */
    disableAuthService(input: DisableAuthServiceRequest, options?: RpcOptions): UnaryCall<DisableAuthServiceRequest, DisableAuthServiceResponse> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<DisableAuthServiceRequest, DisableAuthServiceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateOAuthApp(viam.app.v1.CreateOAuthAppRequest) returns (viam.app.v1.CreateOAuthAppResponse);
     */
    createOAuthApp(input: CreateOAuthAppRequest, options?: RpcOptions): UnaryCall<CreateOAuthAppRequest, CreateOAuthAppResponse> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOAuthAppRequest, CreateOAuthAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReadOAuthApp(viam.app.v1.ReadOAuthAppRequest) returns (viam.app.v1.ReadOAuthAppResponse);
     */
    readOAuthApp(input: ReadOAuthAppRequest, options?: RpcOptions): UnaryCall<ReadOAuthAppRequest, ReadOAuthAppResponse> {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReadOAuthAppRequest, ReadOAuthAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateOAuthApp(viam.app.v1.UpdateOAuthAppRequest) returns (viam.app.v1.UpdateOAuthAppResponse);
     */
    updateOAuthApp(input: UpdateOAuthAppRequest, options?: RpcOptions): UnaryCall<UpdateOAuthAppRequest, UpdateOAuthAppResponse> {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateOAuthAppRequest, UpdateOAuthAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteOAuthApp(viam.app.v1.DeleteOAuthAppRequest) returns (viam.app.v1.DeleteOAuthAppResponse);
     */
    deleteOAuthApp(input: DeleteOAuthAppRequest, options?: RpcOptions): UnaryCall<DeleteOAuthAppRequest, DeleteOAuthAppResponse> {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteOAuthAppRequest, DeleteOAuthAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListOAuthApps(viam.app.v1.ListOAuthAppsRequest) returns (viam.app.v1.ListOAuthAppsResponse);
     */
    listOAuthApps(input: ListOAuthAppsRequest, options?: RpcOptions): UnaryCall<ListOAuthAppsRequest, ListOAuthAppsResponse> {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListOAuthAppsRequest, ListOAuthAppsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateOAuthAppUser(viam.app.v1.CreateOAuthAppUserRequest) returns (viam.app.v1.CreateOAuthAppUserResponse);
     */
    createOAuthAppUser(input: CreateOAuthAppUserRequest, options?: RpcOptions): UnaryCall<CreateOAuthAppUserRequest, CreateOAuthAppUserResponse> {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOAuthAppUserRequest, CreateOAuthAppUserResponse>("unary", this._transport, method, opt, input);
    }
    // Location

    /**
     * Create a location
     *
     * @generated from protobuf rpc: CreateLocation(viam.app.v1.CreateLocationRequest) returns (viam.app.v1.CreateLocationResponse);
     */
    createLocation(input: CreateLocationRequest, options?: RpcOptions): UnaryCall<CreateLocationRequest, CreateLocationResponse> {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateLocationRequest, CreateLocationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a location
     *
     * @generated from protobuf rpc: GetLocation(viam.app.v1.GetLocationRequest) returns (viam.app.v1.GetLocationResponse);
     */
    getLocation(input: GetLocationRequest, options?: RpcOptions): UnaryCall<GetLocationRequest, GetLocationResponse> {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLocationRequest, GetLocationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update a location
     *
     * @generated from protobuf rpc: UpdateLocation(viam.app.v1.UpdateLocationRequest) returns (viam.app.v1.UpdateLocationResponse);
     */
    updateLocation(input: UpdateLocationRequest, options?: RpcOptions): UnaryCall<UpdateLocationRequest, UpdateLocationResponse> {
        const method = this.methods[37], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationRequest, UpdateLocationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a location
     *
     * @generated from protobuf rpc: DeleteLocation(viam.app.v1.DeleteLocationRequest) returns (viam.app.v1.DeleteLocationResponse);
     */
    deleteLocation(input: DeleteLocationRequest, options?: RpcOptions): UnaryCall<DeleteLocationRequest, DeleteLocationResponse> {
        const method = this.methods[38], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteLocationRequest, DeleteLocationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get user-defined metadata for a location
     *
     * @generated from protobuf rpc: GetLocationMetadata(viam.app.v1.GetLocationMetadataRequest) returns (viam.app.v1.GetLocationMetadataResponse);
     */
    getLocationMetadata(input: GetLocationMetadataRequest, options?: RpcOptions): UnaryCall<GetLocationMetadataRequest, GetLocationMetadataResponse> {
        const method = this.methods[39], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetLocationMetadataRequest, GetLocationMetadataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update user-defined metadata for a location
     *
     * @generated from protobuf rpc: UpdateLocationMetadata(viam.app.v1.UpdateLocationMetadataRequest) returns (viam.app.v1.UpdateLocationMetadataResponse);
     */
    updateLocationMetadata(input: UpdateLocationMetadataRequest, options?: RpcOptions): UnaryCall<UpdateLocationMetadataRequest, UpdateLocationMetadataResponse> {
        const method = this.methods[40], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateLocationMetadataRequest, UpdateLocationMetadataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a list of locations
     *
     * @generated from protobuf rpc: ListLocations(viam.app.v1.ListLocationsRequest) returns (viam.app.v1.ListLocationsResponse);
     */
    listLocations(input: ListLocationsRequest, options?: RpcOptions): UnaryCall<ListLocationsRequest, ListLocationsResponse> {
        const method = this.methods[41], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListLocationsRequest, ListLocationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Share a location with an organization
     *
     * @generated from protobuf rpc: ShareLocation(viam.app.v1.ShareLocationRequest) returns (viam.app.v1.ShareLocationResponse);
     */
    shareLocation(input: ShareLocationRequest, options?: RpcOptions): UnaryCall<ShareLocationRequest, ShareLocationResponse> {
        const method = this.methods[42], opt = this._transport.mergeOptions(options);
        return stackIntercept<ShareLocationRequest, ShareLocationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Stop sharing a location with an organization
     *
     * @generated from protobuf rpc: UnshareLocation(viam.app.v1.UnshareLocationRequest) returns (viam.app.v1.UnshareLocationResponse);
     */
    unshareLocation(input: UnshareLocationRequest, options?: RpcOptions): UnaryCall<UnshareLocationRequest, UnshareLocationResponse> {
        const method = this.methods[43], opt = this._transport.mergeOptions(options);
        return stackIntercept<UnshareLocationRequest, UnshareLocationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a location's authorization secrets
     *
     * @generated from protobuf rpc: LocationAuth(viam.app.v1.LocationAuthRequest) returns (viam.app.v1.LocationAuthResponse);
     */
    locationAuth(input: LocationAuthRequest, options?: RpcOptions): UnaryCall<LocationAuthRequest, LocationAuthResponse> {
        const method = this.methods[44], opt = this._transport.mergeOptions(options);
        return stackIntercept<LocationAuthRequest, LocationAuthResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a new generated Secret in the Location.
     *  - Succeeds if there are no more than 2 active secrets after creation.
     *
     * @generated from protobuf rpc: CreateLocationSecret(viam.app.v1.CreateLocationSecretRequest) returns (viam.app.v1.CreateLocationSecretResponse);
     */
    createLocationSecret(input: CreateLocationSecretRequest, options?: RpcOptions): UnaryCall<CreateLocationSecretRequest, CreateLocationSecretResponse> {
        const method = this.methods[45], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateLocationSecretRequest, CreateLocationSecretResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a Secret from the Location.
     *
     * @generated from protobuf rpc: DeleteLocationSecret(viam.app.v1.DeleteLocationSecretRequest) returns (viam.app.v1.DeleteLocationSecretResponse);
     */
    deleteLocationSecret(input: DeleteLocationSecretRequest, options?: RpcOptions): UnaryCall<DeleteLocationSecretRequest, DeleteLocationSecretResponse> {
        const method = this.methods[46], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteLocationSecretRequest, DeleteLocationSecretResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a specific robot by ID
     *
     * @generated from protobuf rpc: GetRobot(viam.app.v1.GetRobotRequest) returns (viam.app.v1.GetRobotResponse);
     */
    getRobot(input: GetRobotRequest, options?: RpcOptions): UnaryCall<GetRobotRequest, GetRobotResponse> {
        const method = this.methods[47], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotRequest, GetRobotResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get user-defined metadata for a robot
     *
     * @generated from protobuf rpc: GetRobotMetadata(viam.app.v1.GetRobotMetadataRequest) returns (viam.app.v1.GetRobotMetadataResponse);
     */
    getRobotMetadata(input: GetRobotMetadataRequest, options?: RpcOptions): UnaryCall<GetRobotMetadataRequest, GetRobotMetadataResponse> {
        const method = this.methods[48], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotMetadataRequest, GetRobotMetadataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update user-defined metadata for an robot
     *
     * @generated from protobuf rpc: UpdateRobotMetadata(viam.app.v1.UpdateRobotMetadataRequest) returns (viam.app.v1.UpdateRobotMetadataResponse);
     */
    updateRobotMetadata(input: UpdateRobotMetadataRequest, options?: RpcOptions): UnaryCall<UpdateRobotMetadataRequest, UpdateRobotMetadataResponse> {
        const method = this.methods[49], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateRobotMetadataRequest, UpdateRobotMetadataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get Rover Rental Location Robots
     *
     * @generated from protobuf rpc: GetRoverRentalRobots(viam.app.v1.GetRoverRentalRobotsRequest) returns (viam.app.v1.GetRoverRentalRobotsResponse);
     */
    getRoverRentalRobots(input: GetRoverRentalRobotsRequest, options?: RpcOptions): UnaryCall<GetRoverRentalRobotsRequest, GetRoverRentalRobotsResponse> {
        const method = this.methods[50], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRoverRentalRobotsRequest, GetRoverRentalRobotsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetRobotParts(viam.app.v1.GetRobotPartsRequest) returns (viam.app.v1.GetRobotPartsResponse);
     */
    getRobotParts(input: GetRobotPartsRequest, options?: RpcOptions): UnaryCall<GetRobotPartsRequest, GetRobotPartsResponse> {
        const method = this.methods[51], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotPartsRequest, GetRobotPartsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a specific robot part by ID
     *
     * @generated from protobuf rpc: GetRobotPart(viam.app.v1.GetRobotPartRequest) returns (viam.app.v1.GetRobotPartResponse);
     */
    getRobotPart(input: GetRobotPartRequest, options?: RpcOptions): UnaryCall<GetRobotPartRequest, GetRobotPartResponse> {
        const method = this.methods[52], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotPartRequest, GetRobotPartResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a specific robot part by name and location
     *
     * @generated from protobuf rpc: GetRobotPartByNameAndLocation(viam.app.v1.GetRobotPartByNameAndLocationRequest) returns (viam.app.v1.GetRobotPartByNameAndLocationResponse);
     */
    getRobotPartByNameAndLocation(input: GetRobotPartByNameAndLocationRequest, options?: RpcOptions): UnaryCall<GetRobotPartByNameAndLocationRequest, GetRobotPartByNameAndLocationResponse> {
        const method = this.methods[53], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotPartByNameAndLocationRequest, GetRobotPartByNameAndLocationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetRobotPartLogs(viam.app.v1.GetRobotPartLogsRequest) returns (viam.app.v1.GetRobotPartLogsResponse);
     */
    getRobotPartLogs(input: GetRobotPartLogsRequest, options?: RpcOptions): UnaryCall<GetRobotPartLogsRequest, GetRobotPartLogsResponse> {
        const method = this.methods[54], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotPartLogsRequest, GetRobotPartLogsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: TailRobotPartLogs(viam.app.v1.TailRobotPartLogsRequest) returns (stream viam.app.v1.TailRobotPartLogsResponse);
     */
    tailRobotPartLogs(input: TailRobotPartLogsRequest, options?: RpcOptions): ServerStreamingCall<TailRobotPartLogsRequest, TailRobotPartLogsResponse> {
        const method = this.methods[55], opt = this._transport.mergeOptions(options);
        return stackIntercept<TailRobotPartLogsRequest, TailRobotPartLogsResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * Get a specific robot part histy by ID
     *
     * @generated from protobuf rpc: GetRobotPartHistory(viam.app.v1.GetRobotPartHistoryRequest) returns (viam.app.v1.GetRobotPartHistoryResponse);
     */
    getRobotPartHistory(input: GetRobotPartHistoryRequest, options?: RpcOptions): UnaryCall<GetRobotPartHistoryRequest, GetRobotPartHistoryResponse> {
        const method = this.methods[56], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotPartHistoryRequest, GetRobotPartHistoryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update a robot
     *
     * @generated from protobuf rpc: UpdateRobotPart(viam.app.v1.UpdateRobotPartRequest) returns (viam.app.v1.UpdateRobotPartResponse);
     */
    updateRobotPart(input: UpdateRobotPartRequest, options?: RpcOptions): UnaryCall<UpdateRobotPartRequest, UpdateRobotPartResponse> {
        const method = this.methods[57], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateRobotPartRequest, UpdateRobotPartResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a new robot part
     *
     * @generated from protobuf rpc: NewRobotPart(viam.app.v1.NewRobotPartRequest) returns (viam.app.v1.NewRobotPartResponse);
     */
    newRobotPart(input: NewRobotPartRequest, options?: RpcOptions): UnaryCall<NewRobotPartRequest, NewRobotPartResponse> {
        const method = this.methods[58], opt = this._transport.mergeOptions(options);
        return stackIntercept<NewRobotPartRequest, NewRobotPartResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a robot part
     *
     * @generated from protobuf rpc: DeleteRobotPart(viam.app.v1.DeleteRobotPartRequest) returns (viam.app.v1.DeleteRobotPartResponse);
     */
    deleteRobotPart(input: DeleteRobotPartRequest, options?: RpcOptions): UnaryCall<DeleteRobotPartRequest, DeleteRobotPartResponse> {
        const method = this.methods[59], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteRobotPartRequest, DeleteRobotPartResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get user-defined metadata for a robot part
     *
     * @generated from protobuf rpc: GetRobotPartMetadata(viam.app.v1.GetRobotPartMetadataRequest) returns (viam.app.v1.GetRobotPartMetadataResponse);
     */
    getRobotPartMetadata(input: GetRobotPartMetadataRequest, options?: RpcOptions): UnaryCall<GetRobotPartMetadataRequest, GetRobotPartMetadataResponse> {
        const method = this.methods[60], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotPartMetadataRequest, GetRobotPartMetadataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Update user-defined metadata for an robot part
     *
     * @generated from protobuf rpc: UpdateRobotPartMetadata(viam.app.v1.UpdateRobotPartMetadataRequest) returns (viam.app.v1.UpdateRobotPartMetadataResponse);
     */
    updateRobotPartMetadata(input: UpdateRobotPartMetadataRequest, options?: RpcOptions): UnaryCall<UpdateRobotPartMetadataRequest, UpdateRobotPartMetadataResponse> {
        const method = this.methods[61], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateRobotPartMetadataRequest, UpdateRobotPartMetadataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Gets the Robot API Keys for the robot
     *
     * @generated from protobuf rpc: GetRobotAPIKeys(viam.app.v1.GetRobotAPIKeysRequest) returns (viam.app.v1.GetRobotAPIKeysResponse);
     */
    getRobotAPIKeys(input: GetRobotAPIKeysRequest, options?: RpcOptions): UnaryCall<GetRobotAPIKeysRequest, GetRobotAPIKeysResponse> {
        const method = this.methods[62], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRobotAPIKeysRequest, GetRobotAPIKeysResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Marks the given part as the main part, and all the others as not
     *
     * @generated from protobuf rpc: MarkPartAsMain(viam.app.v1.MarkPartAsMainRequest) returns (viam.app.v1.MarkPartAsMainResponse);
     */
    markPartAsMain(input: MarkPartAsMainRequest, options?: RpcOptions): UnaryCall<MarkPartAsMainRequest, MarkPartAsMainResponse> {
        const method = this.methods[63], opt = this._transport.mergeOptions(options);
        return stackIntercept<MarkPartAsMainRequest, MarkPartAsMainResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Marks part for restart. Once the robot part checks-in with the app the flag
     * is reset on the robot part. Calling this multiple times before a robot part
     * checks-in has no affect.
     * Note: This API may be removed in the near future.
     * TODO(APP-388): Remove
     *
     * @generated from protobuf rpc: MarkPartForRestart(viam.app.v1.MarkPartForRestartRequest) returns (viam.app.v1.MarkPartForRestartResponse);
     */
    markPartForRestart(input: MarkPartForRestartRequest, options?: RpcOptions): UnaryCall<MarkPartForRestartRequest, MarkPartForRestartResponse> {
        const method = this.methods[64], opt = this._transport.mergeOptions(options);
        return stackIntercept<MarkPartForRestartRequest, MarkPartForRestartResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Create a new generated Secret in the Robot Part.
     *  - Succeeds if there are no more than 2 active secrets after creation.
     *
     * @generated from protobuf rpc: CreateRobotPartSecret(viam.app.v1.CreateRobotPartSecretRequest) returns (viam.app.v1.CreateRobotPartSecretResponse);
     */
    createRobotPartSecret(input: CreateRobotPartSecretRequest, options?: RpcOptions): UnaryCall<CreateRobotPartSecretRequest, CreateRobotPartSecretResponse> {
        const method = this.methods[65], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateRobotPartSecretRequest, CreateRobotPartSecretResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a Secret from the RobotPart.
     *
     * @generated from protobuf rpc: DeleteRobotPartSecret(viam.app.v1.DeleteRobotPartSecretRequest) returns (viam.app.v1.DeleteRobotPartSecretResponse);
     */
    deleteRobotPartSecret(input: DeleteRobotPartSecretRequest, options?: RpcOptions): UnaryCall<DeleteRobotPartSecretRequest, DeleteRobotPartSecretResponse> {
        const method = this.methods[66], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteRobotPartSecretRequest, DeleteRobotPartSecretResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a list of robots at a location
     *
     * @generated from protobuf rpc: ListRobots(viam.app.v1.ListRobotsRequest) returns (viam.app.v1.ListRobotsResponse);
     */
    listRobots(input: ListRobotsRequest, options?: RpcOptions): UnaryCall<ListRobotsRequest, ListRobotsResponse> {
        const method = this.methods[67], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListRobotsRequest, ListRobotsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a list of robots at multiple locations
     *
     * @generated from protobuf rpc: ListRobotsForLocations(viam.app.v1.ListRobotsForLocationsRequest) returns (viam.app.v1.ListRobotsForLocationsResponse);
     */
    listRobotsForLocations(input: ListRobotsForLocationsRequest, options?: RpcOptions): UnaryCall<ListRobotsForLocationsRequest, ListRobotsForLocationsResponse> {
        const method = this.methods[68], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListRobotsForLocationsRequest, ListRobotsForLocationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a list of robots at an org
     *
     * @generated from protobuf rpc: ListRobotsForOrg(viam.app.v1.ListRobotsForOrgRequest) returns (viam.app.v1.ListRobotsForOrgResponse);
     */
    listRobotsForOrg(input: ListRobotsForOrgRequest, options?: RpcOptions): UnaryCall<ListRobotsForOrgRequest, ListRobotsForOrgResponse> {
        const method = this.methods[69], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListRobotsForOrgRequest, ListRobotsForOrgResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * NewRobot creates a new robot
     *
     * @generated from protobuf rpc: NewRobot(viam.app.v1.NewRobotRequest) returns (viam.app.v1.NewRobotResponse);
     */
    newRobot(input: NewRobotRequest, options?: RpcOptions): UnaryCall<NewRobotRequest, NewRobotResponse> {
        const method = this.methods[70], opt = this._transport.mergeOptions(options);
        return stackIntercept<NewRobotRequest, NewRobotResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * UpdateRobot updates a robot
     *
     * @generated from protobuf rpc: UpdateRobot(viam.app.v1.UpdateRobotRequest) returns (viam.app.v1.UpdateRobotResponse);
     */
    updateRobot(input: UpdateRobotRequest, options?: RpcOptions): UnaryCall<UpdateRobotRequest, UpdateRobotResponse> {
        const method = this.methods[71], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateRobotRequest, UpdateRobotResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteRobot deletes a robot
     *
     * @generated from protobuf rpc: DeleteRobot(viam.app.v1.DeleteRobotRequest) returns (viam.app.v1.DeleteRobotResponse);
     */
    deleteRobot(input: DeleteRobotRequest, options?: RpcOptions): UnaryCall<DeleteRobotRequest, DeleteRobotResponse> {
        const method = this.methods[72], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteRobotRequest, DeleteRobotResponse>("unary", this._transport, method, opt, input);
    }
    // Fragments

    /**
     * Gets a list of fragments
     *
     * @generated from protobuf rpc: ListFragments(viam.app.v1.ListFragmentsRequest) returns (viam.app.v1.ListFragmentsResponse);
     */
    listFragments(input: ListFragmentsRequest, options?: RpcOptions): UnaryCall<ListFragmentsRequest, ListFragmentsResponse> {
        const method = this.methods[73], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListFragmentsRequest, ListFragmentsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Gets a single fragment
     *
     * @generated from protobuf rpc: GetFragment(viam.app.v1.GetFragmentRequest) returns (viam.app.v1.GetFragmentResponse);
     */
    getFragment(input: GetFragmentRequest, options?: RpcOptions): UnaryCall<GetFragmentRequest, GetFragmentResponse> {
        const method = this.methods[74], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetFragmentRequest, GetFragmentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Creates a fragment
     *
     * @generated from protobuf rpc: CreateFragment(viam.app.v1.CreateFragmentRequest) returns (viam.app.v1.CreateFragmentResponse);
     */
    createFragment(input: CreateFragmentRequest, options?: RpcOptions): UnaryCall<CreateFragmentRequest, CreateFragmentResponse> {
        const method = this.methods[75], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateFragmentRequest, CreateFragmentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Updates a fragment
     *
     * @generated from protobuf rpc: UpdateFragment(viam.app.v1.UpdateFragmentRequest) returns (viam.app.v1.UpdateFragmentResponse);
     */
    updateFragment(input: UpdateFragmentRequest, options?: RpcOptions): UnaryCall<UpdateFragmentRequest, UpdateFragmentResponse> {
        const method = this.methods[76], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateFragmentRequest, UpdateFragmentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a fragment
     *
     * @generated from protobuf rpc: DeleteFragment(viam.app.v1.DeleteFragmentRequest) returns (viam.app.v1.DeleteFragmentResponse);
     */
    deleteFragment(input: DeleteFragmentRequest, options?: RpcOptions): UnaryCall<DeleteFragmentRequest, DeleteFragmentResponse> {
        const method = this.methods[77], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteFragmentRequest, DeleteFragmentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List nested fragments for a fragment
     *
     * @generated from protobuf rpc: ListNestedFragments(viam.app.v1.ListNestedFragmentsRequest) returns (viam.app.v1.ListNestedFragmentsResponse);
     */
    listNestedFragments(input: ListNestedFragmentsRequest, options?: RpcOptions): UnaryCall<ListNestedFragmentsRequest, ListNestedFragmentsResponse> {
        const method = this.methods[78], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListNestedFragmentsRequest, ListNestedFragmentsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Gets top level and nested fragments for a machine, as well as any other specified fragment ids
     *
     * @generated from protobuf rpc: ListMachineFragments(viam.app.v1.ListMachineFragmentsRequest) returns (viam.app.v1.ListMachineFragmentsResponse);
     */
    listMachineFragments(input: ListMachineFragmentsRequest, options?: RpcOptions): UnaryCall<ListMachineFragmentsRequest, ListMachineFragmentsResponse> {
        const method = this.methods[79], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListMachineFragmentsRequest, ListMachineFragmentsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List all machines and their corresponding machine dashboard information
     *
     * @generated from protobuf rpc: ListMachineSummaries(viam.app.v1.ListMachineSummariesRequest) returns (viam.app.v1.ListMachineSummariesResponse);
     */
    listMachineSummaries(input: ListMachineSummariesRequest, options?: RpcOptions): UnaryCall<ListMachineSummariesRequest, ListMachineSummariesResponse> {
        const method = this.methods[80], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListMachineSummariesRequest, ListMachineSummariesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Gets fragment history
     *
     * @generated from protobuf rpc: GetFragmentHistory(viam.app.v1.GetFragmentHistoryRequest) returns (viam.app.v1.GetFragmentHistoryResponse);
     */
    getFragmentHistory(input: GetFragmentHistoryRequest, options?: RpcOptions): UnaryCall<GetFragmentHistoryRequest, GetFragmentHistoryResponse> {
        const method = this.methods[81], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetFragmentHistoryRequest, GetFragmentHistoryResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Gets usage for a fragment across versions
     *
     * @generated from protobuf rpc: GetFragmentUsage(viam.app.v1.GetFragmentUsageRequest) returns (viam.app.v1.GetFragmentUsageResponse);
     */
    getFragmentUsage(input: GetFragmentUsageRequest, options?: RpcOptions): UnaryCall<GetFragmentUsageRequest, GetFragmentUsageResponse> {
        const method = this.methods[82], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetFragmentUsageRequest, GetFragmentUsageResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Sets a fragment tag to a revision
     *
     * @generated from protobuf rpc: SetFragmentTag(viam.app.v1.SetFragmentTagRequest) returns (viam.app.v1.SetFragmentTagResponse);
     */
    setFragmentTag(input: SetFragmentTagRequest, options?: RpcOptions): UnaryCall<SetFragmentTagRequest, SetFragmentTagResponse> {
        const method = this.methods[83], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetFragmentTagRequest, SetFragmentTagResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a fragment tag
     *
     * @generated from protobuf rpc: DeleteFragmentTag(viam.app.v1.DeleteFragmentTagRequest) returns (viam.app.v1.DeleteFragmentTagResponse);
     */
    deleteFragmentTag(input: DeleteFragmentTagRequest, options?: RpcOptions): UnaryCall<DeleteFragmentTagRequest, DeleteFragmentTagResponse> {
        const method = this.methods[84], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteFragmentTagRequest, DeleteFragmentTagResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Creates an IdentityAuthorization
     *
     * @generated from protobuf rpc: AddRole(viam.app.v1.AddRoleRequest) returns (viam.app.v1.AddRoleResponse);
     */
    addRole(input: AddRoleRequest, options?: RpcOptions): UnaryCall<AddRoleRequest, AddRoleResponse> {
        const method = this.methods[85], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddRoleRequest, AddRoleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes an IdentityAuthorization
     *
     * @generated from protobuf rpc: RemoveRole(viam.app.v1.RemoveRoleRequest) returns (viam.app.v1.RemoveRoleResponse);
     */
    removeRole(input: RemoveRoleRequest, options?: RpcOptions): UnaryCall<RemoveRoleRequest, RemoveRoleResponse> {
        const method = this.methods[86], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoveRoleRequest, RemoveRoleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Changes an IdentityAuthorization to a new IdentityAuthorization
     *
     * @generated from protobuf rpc: ChangeRole(viam.app.v1.ChangeRoleRequest) returns (viam.app.v1.ChangeRoleResponse);
     */
    changeRole(input: ChangeRoleRequest, options?: RpcOptions): UnaryCall<ChangeRoleRequest, ChangeRoleResponse> {
        const method = this.methods[87], opt = this._transport.mergeOptions(options);
        return stackIntercept<ChangeRoleRequest, ChangeRoleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Returns all authorization roles for a given resource
     *
     * @generated from protobuf rpc: ListAuthorizations(viam.app.v1.ListAuthorizationsRequest) returns (viam.app.v1.ListAuthorizationsResponse);
     */
    listAuthorizations(input: ListAuthorizationsRequest, options?: RpcOptions): UnaryCall<ListAuthorizationsRequest, ListAuthorizationsResponse> {
        const method = this.methods[88], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAuthorizationsRequest, ListAuthorizationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Validates a permission for the current user
     *
     * @generated from protobuf rpc: CheckPermissions(viam.app.v1.CheckPermissionsRequest) returns (viam.app.v1.CheckPermissionsResponse);
     */
    checkPermissions(input: CheckPermissionsRequest, options?: RpcOptions): UnaryCall<CheckPermissionsRequest, CheckPermissionsResponse> {
        const method = this.methods[89], opt = this._transport.mergeOptions(options);
        return stackIntercept<CheckPermissionsRequest, CheckPermissionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetRegistryItem(viam.app.v1.GetRegistryItemRequest) returns (viam.app.v1.GetRegistryItemResponse);
     */
    getRegistryItem(input: GetRegistryItemRequest, options?: RpcOptions): UnaryCall<GetRegistryItemRequest, GetRegistryItemResponse> {
        const method = this.methods[90], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetRegistryItemRequest, GetRegistryItemResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateRegistryItem(viam.app.v1.CreateRegistryItemRequest) returns (viam.app.v1.CreateRegistryItemResponse);
     */
    createRegistryItem(input: CreateRegistryItemRequest, options?: RpcOptions): UnaryCall<CreateRegistryItemRequest, CreateRegistryItemResponse> {
        const method = this.methods[91], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateRegistryItemRequest, CreateRegistryItemResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateRegistryItem(viam.app.v1.UpdateRegistryItemRequest) returns (viam.app.v1.UpdateRegistryItemResponse);
     */
    updateRegistryItem(input: UpdateRegistryItemRequest, options?: RpcOptions): UnaryCall<UpdateRegistryItemRequest, UpdateRegistryItemResponse> {
        const method = this.methods[92], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateRegistryItemRequest, UpdateRegistryItemResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListRegistryItems(viam.app.v1.ListRegistryItemsRequest) returns (viam.app.v1.ListRegistryItemsResponse);
     */
    listRegistryItems(input: ListRegistryItemsRequest, options?: RpcOptions): UnaryCall<ListRegistryItemsRequest, ListRegistryItemsResponse> {
        const method = this.methods[93], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListRegistryItemsRequest, ListRegistryItemsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteRegistryItem(viam.app.v1.DeleteRegistryItemRequest) returns (viam.app.v1.DeleteRegistryItemResponse);
     */
    deleteRegistryItem(input: DeleteRegistryItemRequest, options?: RpcOptions): UnaryCall<DeleteRegistryItemRequest, DeleteRegistryItemResponse> {
        const method = this.methods[94], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteRegistryItemRequest, DeleteRegistryItemResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RenameRegistryItem(viam.app.v1.RenameRegistryItemRequest) returns (viam.app.v1.RenameRegistryItemResponse);
     */
    renameRegistryItem(input: RenameRegistryItemRequest, options?: RpcOptions): UnaryCall<RenameRegistryItemRequest, RenameRegistryItemResponse> {
        const method = this.methods[95], opt = this._transport.mergeOptions(options);
        return stackIntercept<RenameRegistryItemRequest, RenameRegistryItemResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: TransferRegistryItem(viam.app.v1.TransferRegistryItemRequest) returns (viam.app.v1.TransferRegistryItemResponse);
     */
    transferRegistryItem(input: TransferRegistryItemRequest, options?: RpcOptions): UnaryCall<TransferRegistryItemRequest, TransferRegistryItemResponse> {
        const method = this.methods[96], opt = this._transport.mergeOptions(options);
        return stackIntercept<TransferRegistryItemRequest, TransferRegistryItemResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeprecateRegistryItem(viam.app.v1.DeprecateRegistryItemRequest) returns (viam.app.v1.DeprecateRegistryItemResponse);
     */
    deprecateRegistryItem(input: DeprecateRegistryItemRequest, options?: RpcOptions): UnaryCall<DeprecateRegistryItemRequest, DeprecateRegistryItemResponse> {
        const method = this.methods[97], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeprecateRegistryItemRequest, DeprecateRegistryItemResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UndeprecateRegistryItem(viam.app.v1.UndeprecateRegistryItemRequest) returns (viam.app.v1.UndeprecateRegistryItemResponse);
     */
    undeprecateRegistryItem(input: UndeprecateRegistryItemRequest, options?: RpcOptions): UnaryCall<UndeprecateRegistryItemRequest, UndeprecateRegistryItemResponse> {
        const method = this.methods[98], opt = this._transport.mergeOptions(options);
        return stackIntercept<UndeprecateRegistryItemRequest, UndeprecateRegistryItemResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateModule(viam.app.v1.CreateModuleRequest) returns (viam.app.v1.CreateModuleResponse);
     */
    createModule(input: CreateModuleRequest, options?: RpcOptions): UnaryCall<CreateModuleRequest, CreateModuleResponse> {
        const method = this.methods[99], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateModuleRequest, CreateModuleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateModule(viam.app.v1.UpdateModuleRequest) returns (viam.app.v1.UpdateModuleResponse);
     */
    updateModule(input: UpdateModuleRequest, options?: RpcOptions): UnaryCall<UpdateModuleRequest, UpdateModuleResponse> {
        const method = this.methods[100], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateModuleRequest, UpdateModuleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UploadModuleFile(stream viam.app.v1.UploadModuleFileRequest) returns (viam.app.v1.UploadModuleFileResponse);
     */
    uploadModuleFile(options?: RpcOptions): ClientStreamingCall<UploadModuleFileRequest, UploadModuleFileResponse> {
        const method = this.methods[101], opt = this._transport.mergeOptions(options);
        return stackIntercept<UploadModuleFileRequest, UploadModuleFileResponse>("clientStreaming", this._transport, method, opt);
    }
    /**
     * @generated from protobuf rpc: GetModule(viam.app.v1.GetModuleRequest) returns (viam.app.v1.GetModuleResponse);
     */
    getModule(input: GetModuleRequest, options?: RpcOptions): UnaryCall<GetModuleRequest, GetModuleResponse> {
        const method = this.methods[102], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetModuleRequest, GetModuleResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListModules(viam.app.v1.ListModulesRequest) returns (viam.app.v1.ListModulesResponse);
     */
    listModules(input: ListModulesRequest, options?: RpcOptions): UnaryCall<ListModulesRequest, ListModulesResponse> {
        const method = this.methods[103], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListModulesRequest, ListModulesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeprecateRegistryItemVersion(viam.app.v1.DeprecateRegistryItemVersionRequest) returns (viam.app.v1.DeprecateRegistryItemVersionResponse);
     */
    deprecateRegistryItemVersion(input: DeprecateRegistryItemVersionRequest, options?: RpcOptions): UnaryCall<DeprecateRegistryItemVersionRequest, DeprecateRegistryItemVersionResponse> {
        const method = this.methods[104], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeprecateRegistryItemVersionRequest, DeprecateRegistryItemVersionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UndeprecateRegistryItemVersion(viam.app.v1.UndeprecateRegistryItemVersionRequest) returns (viam.app.v1.UndeprecateRegistryItemVersionResponse);
     */
    undeprecateRegistryItemVersion(input: UndeprecateRegistryItemVersionRequest, options?: RpcOptions): UnaryCall<UndeprecateRegistryItemVersionRequest, UndeprecateRegistryItemVersionResponse> {
        const method = this.methods[105], opt = this._transport.mergeOptions(options);
        return stackIntercept<UndeprecateRegistryItemVersionRequest, UndeprecateRegistryItemVersionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateKey(viam.app.v1.CreateKeyRequest) returns (viam.app.v1.CreateKeyResponse);
     */
    createKey(input: CreateKeyRequest, options?: RpcOptions): UnaryCall<CreateKeyRequest, CreateKeyResponse> {
        const method = this.methods[106], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateKeyRequest, CreateKeyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteKey(viam.app.v1.DeleteKeyRequest) returns (viam.app.v1.DeleteKeyResponse);
     */
    deleteKey(input: DeleteKeyRequest, options?: RpcOptions): UnaryCall<DeleteKeyRequest, DeleteKeyResponse> {
        const method = this.methods[107], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteKeyRequest, DeleteKeyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListKeys(viam.app.v1.ListKeysRequest) returns (viam.app.v1.ListKeysResponse);
     */
    listKeys(input: ListKeysRequest, options?: RpcOptions): UnaryCall<ListKeysRequest, ListKeysResponse> {
        const method = this.methods[108], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListKeysRequest, ListKeysResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RenameKey(viam.app.v1.RenameKeyRequest) returns (viam.app.v1.RenameKeyResponse);
     */
    renameKey(input: RenameKeyRequest, options?: RpcOptions): UnaryCall<RenameKeyRequest, RenameKeyResponse> {
        const method = this.methods[109], opt = this._transport.mergeOptions(options);
        return stackIntercept<RenameKeyRequest, RenameKeyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RotateKey(viam.app.v1.RotateKeyRequest) returns (viam.app.v1.RotateKeyResponse);
     */
    rotateKey(input: RotateKeyRequest, options?: RpcOptions): UnaryCall<RotateKeyRequest, RotateKeyResponse> {
        const method = this.methods[110], opt = this._transport.mergeOptions(options);
        return stackIntercept<RotateKeyRequest, RotateKeyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateKeyFromExistingKeyAuthorizations(viam.app.v1.CreateKeyFromExistingKeyAuthorizationsRequest) returns (viam.app.v1.CreateKeyFromExistingKeyAuthorizationsResponse);
     */
    createKeyFromExistingKeyAuthorizations(input: CreateKeyFromExistingKeyAuthorizationsRequest, options?: RpcOptions): UnaryCall<CreateKeyFromExistingKeyAuthorizationsRequest, CreateKeyFromExistingKeyAuthorizationsResponse> {
        const method = this.methods[111], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateKeyFromExistingKeyAuthorizationsRequest, CreateKeyFromExistingKeyAuthorizationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAppContent(viam.app.v1.GetAppContentRequest) returns (viam.app.v1.GetAppContentResponse);
     */
    getAppContent(input: GetAppContentRequest, options?: RpcOptions): UnaryCall<GetAppContentRequest, GetAppContentResponse> {
        const method = this.methods[112], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppContentRequest, GetAppContentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAppBranding(viam.app.v1.GetAppBrandingRequest) returns (viam.app.v1.GetAppBrandingResponse);
     */
    getAppBranding(input: GetAppBrandingRequest, options?: RpcOptions): UnaryCall<GetAppBrandingRequest, GetAppBrandingResponse> {
        const method = this.methods[113], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppBrandingRequest, GetAppBrandingResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Upload a device push token for the user.
     *
     * @generated from protobuf rpc: UploadDevicePushToken(viam.app.v1.UploadDevicePushTokenRequest) returns (viam.app.v1.UploadDevicePushTokenResponse);
     */
    uploadDevicePushToken(input: UploadDevicePushTokenRequest, options?: RpcOptions): UnaryCall<UploadDevicePushTokenRequest, UploadDevicePushTokenResponse> {
        const method = this.methods[114], opt = this._transport.mergeOptions(options);
        return stackIntercept<UploadDevicePushTokenRequest, UploadDevicePushTokenResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Delete a device push token for the user.
     *
     * @generated from protobuf rpc: DeleteDevicePushToken(viam.app.v1.DeleteDevicePushTokenRequest) returns (viam.app.v1.DeleteDevicePushTokenResponse);
     */
    deleteDevicePushToken(input: DeleteDevicePushTokenRequest, options?: RpcOptions): UnaryCall<DeleteDevicePushTokenRequest, DeleteDevicePushTokenResponse> {
        const method = this.methods[115], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteDevicePushTokenRequest, DeleteDevicePushTokenResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Gets all device push tokens for the user for the given app ID.
     *
     * @generated from protobuf rpc: GetDevicePushTokens(viam.app.v1.GetDevicePushTokensRequest) returns (viam.app.v1.GetDevicePushTokensResponse);
     */
    getDevicePushTokens(input: GetDevicePushTokensRequest, options?: RpcOptions): UnaryCall<GetDevicePushTokensRequest, GetDevicePushTokensResponse> {
        const method = this.methods[116], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDevicePushTokensRequest, GetDevicePushTokensResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Set the Firebase config JSON for a specific app id.
     *
     * @generated from protobuf rpc: SetFirebaseConfig(viam.app.v1.SetFirebaseConfigRequest) returns (viam.app.v1.SetFirebaseConfigResponse);
     */
    setFirebaseConfig(input: SetFirebaseConfigRequest, options?: RpcOptions): UnaryCall<SetFirebaseConfigRequest, SetFirebaseConfigResponse> {
        const method = this.methods[117], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetFirebaseConfigRequest, SetFirebaseConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Read the app ID for an organization.
     * This returns only the app_id configured for the org, not the Firebase config JSON.
     *
     * @generated from protobuf rpc: GetFirebaseConfig(viam.app.v1.GetFirebaseConfigRequest) returns (viam.app.v1.GetFirebaseConfigResponse);
     */
    getFirebaseConfig(input: GetFirebaseConfigRequest, options?: RpcOptions): UnaryCall<GetFirebaseConfigRequest, GetFirebaseConfigResponse> {
        const method = this.methods[118], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetFirebaseConfigRequest, GetFirebaseConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Deletes a Firebase config JSON for a specific app id.
     *
     * @generated from protobuf rpc: DeleteFirebaseConfig(viam.app.v1.DeleteFirebaseConfigRequest) returns (viam.app.v1.DeleteFirebaseConfigResponse);
     */
    deleteFirebaseConfig(input: DeleteFirebaseConfigRequest, options?: RpcOptions): UnaryCall<DeleteFirebaseConfigRequest, DeleteFirebaseConfigResponse> {
        const method = this.methods[119], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteFirebaseConfigRequest, DeleteFirebaseConfigResponse>("unary", this._transport, method, opt, input);
    }
}
